/**-----------------------------------------------------------------------------------------
* Copyright © 2023 Progress Software Corporation. All rights reserved.
* Licensed under commercial license. See LICENSE.md in the package root for more information
*-------------------------------------------------------------------------------------------*/
"use client";
import * as n from "react";
import r from "prop-types";
import { useInternationalization as Mn, useLocalization as _e, provideLocalizationService as Je, registerForIntl as Nn, registerForLocalization as da } from "@progress/kendo-react-intl";
import { createPropsContext as he, validatePackage as pe, usePropsContext as Re, useId as Qe, useCustomComponent as qe, dispatchEvent as Q, getActiveElement as wa, classNames as G, kendoThemeMaps as ne, getTabIndex as ie, withIdHOC as et, withPropsContext as Ue, useDir as Ae, Keys as z, Draggable as en, IconWrap as fe, focusFirstFocusableChild as tn, svgIconPropType as Ft, useDraggable as Pn, noop as Me, useRtl as Dn, toIconName as Lt, useAsyncFocusBlur as Bn } from "@progress/kendo-react-common";
import { caretAltUpIcon as Tt, caretAltDownIcon as ht, caretAltExpandIcon as On, caretAltLeftIcon as Ia, caretAltRightIcon as La, checkIcon as Rt, xIcon as zt, dropletSliderIcon as Fn, paletteIcon as Tn, dropletSlashIcon as zn, starOutlineIcon as Ra, starIcon as Va, hyperlinkOpenIcon as Ma } from "@progress/kendo-svg-icons";
import { FloatingLabel as ua, Label as We } from "@progress/kendo-react-labels";
import { Button as ge, ButtonGroup as _n } from "@progress/kendo-react-buttons";
import { parseColor as mt, Color as an } from "@progress/kendo-drawing";
import { Popup as An } from "@progress/kendo-react-popup";
import { SignaturePad as $n } from "@progress/kendo-inputs-common";
import { Dialog as Hn } from "@progress/kendo-react-dialogs";
const me = {
  name: "@progress/kendo-react-inputs",
  productName: "KendoReact",
  productCodes: ["KENDOUIREACT", "KENDOUICOMPLETE"],
  publishDate: 1702644751,
  version: "",
  licensingDocsUrl: "https://www.telerik.com/kendo-react-ui/components/my-license/"
}, Xe = "numerictextbox.increment", Ye = "numerictextbox.decrement", _t = "slider.increment", At = "slider.decrement", Te = "slider.dragTitle", Fe = "colorGradient.r", nn = "colorGradient.g", sn = "colorGradient.b", rn = "colorGradient.a", ln = "colorGradient.hex", $t = "colorGradient.contrastRatio", Ht = "colorGradient.colorGradientAALevel", Gt = "colorGradient.colorGradientAAALevel", Kt = "colorGradient.colorGradientPass", qt = "colorGradient.colorGradientFail", Ut = "colorGradient.hueSliderLabel", jt = "colorGradient.alphaSliderLabel", Wt = "colorGradient.toggleInputsButton", on = "flatColorPicker.cancelBtn", cn = "flatColorPicker.applyBtn", Xt = "flatColorPicker.colorGradientBtn", Yt = "flatColorPicker.colorPaletteBtn", Zt = "flatColorPicker.clearBtn", dn = "checkbox.validation", un = "checkbox.optionalText", Gn = "radioButton.validation", Jt = "switch.validation", Qt = "colorPicker.dropdownButtonAriaLabel", ea = "rating.ariaLabel", ta = "signature.clear", aa = "signature.maximize", na = "signature.minimize", $ = {
  [Xe]: "Increase value",
  [Ye]: "Decrease value",
  [_t]: "Increase",
  [At]: "Decrease",
  [Te]: "Drag",
  [Fe]: "r",
  [nn]: "g",
  [sn]: "b",
  [rn]: "a",
  [ln]: "hex",
  [$t]: "Contrast ratio",
  [Ht]: "AA",
  [Gt]: "AAA",
  [Kt]: "Pass",
  [qt]: "Fail",
  [Ut]: "Hue slider",
  [jt]: "Alpha slider",
  [Wt]: "Toggle colorgradient inputs",
  [on]: "Cancel",
  [cn]: "Apply",
  [Xt]: "Color Gradient view",
  [Yt]: "Color Palette view",
  [Zt]: "Clear color value",
  [dn]: "Please check this box if you want to proceed!",
  [un]: "(Optional)",
  [Gn]: "Please select option if you want to proceed!",
  [Jt]: "Please turn on if you want to proceed!",
  [Qt]: "Select",
  [ea]: "Rating",
  [ta]: "Clear",
  [aa]: "Maximize",
  [na]: "Minimize"
}, pt = 11111111111111e-7, Kn = 0.31111111111111117, qn = 1, fn = 1, hn = 0, ke = /\d/, pn = 15, Na = () => ({
  eventValue: null,
  prevLooseValue: "",
  currentLooseValue: "",
  focused: !1,
  selectionStart: void 0,
  selectionEnd: void 0,
  decimalSelect: !1,
  valueIsCorrected: !1,
  valueIsOutOfRange: !1
}), Vt = (a, t) => a !== void 0 ? a : t, ue = (a, t, e) => a === null && a === void 0 ? "" : typeof a == "string" ? a : e.formatNumber(a, t), Pa = (a) => (String(a).split(".")[1] || "").length, mn = (a, t) => Math.max(Pa(a), Pa(t)), Un = (a) => Math.min(a, pn), gn = (a, t) => {
  const e = Un(t);
  return parseFloat(a.toFixed(e));
}, Da = (a, t, e, s, l, i, c) => {
  const o = mn(a || 0, e || 0), f = Ge(gn((a || 0) + (e || 0), o), s, l);
  t.eventValue = f, t.currentLooseValue = ue(f, i, c), t.selectionStart = t.selectionEnd = Ze(t.currentLooseValue, ke);
}, Ba = (a, t, e, s, l, i, c) => {
  const o = mn(a || 0, e || 0), f = Ge(gn((a || 0) - (e || 0), o), s, l);
  t.eventValue = f, t.currentLooseValue = ue(f, i, c), t.selectionStart = t.selectionEnd = Ze(t.currentLooseValue, ke);
}, Ge = (a, t, e) => a == null ? a : !(a > 1 || a < 1 || a === 1) || e !== void 0 && t !== void 0 && e < t ? null : (e !== void 0 && a > e && (a = e), t !== void 0 && a < t && (a = t), a), jn = (a, t) => {
  const e = t.findIndex(([l, i]) => !!i && a.indexOf(i) === a.length - i.length);
  if (e === -1)
    return -1;
  const s = t[e][1];
  return a.length - s.length;
}, Wn = (a, t) => {
  const e = t.findIndex(([l, i]) => !!l && a.indexOf(l) === 0);
  return e === -1 ? -1 : t[e][0].length;
}, Xn = (a, t, e) => {
  const s = jn(a, t);
  if (s !== -1 && e.selectionStart > s) {
    e.selectionStart = e.selectionEnd = s;
    return;
  }
  e.selectionStart > a.length && (e.selectionStart = e.selectionEnd = a.length);
  const l = Wn(a, t);
  l !== -1 && e.selectionStart < l && (e.selectionStart = e.selectionEnd = l), e.selectionStart === -1 && (e.selectionStart = e.selectionEnd = 0);
}, Le = (a, t, e, s) => {
  a.selectionStart = a.selectionEnd = t, Xn(e, s, a);
}, Mt = (a, t, e, s) => {
  a.eventValue = s.parseNumber(a.prevLooseValue, t), a.currentLooseValue = a.prevLooseValue, a.valueIsCorrected = !0, Le(a, a.selectionStart, a.currentLooseValue, e);
}, Yn = (a, t) => {
  const e = String(a.currentLooseValue), s = String(a.prevLooseValue);
  return e.split(t.minusSign).length !== s.split(t.minusSign).length && e.length === s.length + t.minusSign.length;
}, Zn = (a, t) => {
  const e = String(a.currentLooseValue), s = String(a.prevLooseValue);
  return e.indexOf(t.minusSign) === -1 && s.indexOf(t.minusSign) !== -1;
}, Jn = (a, t) => String(a.currentLooseValue).split(t.decimal).length > 2, Qn = (a, t) => {
  const e = t.formatNumber(pt, a), s = t.formatNumber(-pt, a), l = t.formatNumber(hn, a), i = t.formatNumber(fn, a), c = nt(e), o = nt(s), f = nt(l), d = nt(i), m = st(e), u = st(s), h = st(l), y = st(i);
  return {
    positiveInfo: [c, m],
    negativeInfo: [o, u],
    zeroInfo: [f, h],
    oneInfo: [d, y]
  };
}, es = (a, t) => {
  const e = t.formatNumber(pt, a), s = t.formatNumber(-pt, a), l = t.formatNumber(hn, a), i = t.formatNumber(fn, a), c = t.numberSymbols(), o = new RegExp(`[\\d\\${c.decimal}${c.group}]`, "g");
  return [e, s, l, i].map((d) => d.replace(o, "")).join("").split("").filter((d, m, u) => u.indexOf(d) === m).join("");
}, Nt = (a, t) => {
  const e = a.indexOf(t.decimal);
  return e > -1 ? e : Ze(a, ke);
}, sa = (a) => a.split("").reverse().join(""), Ze = (a, t) => a.length - sa(a).search(t), nt = (a) => a.split(a[a.search(ke)])[0], st = (a) => {
  const t = sa(a);
  return sa(t.split(t[t.search(ke)])[0]);
}, Pt = (a, t) => a.search(t), Oa = (a, t) => {
  const e = a.indexOf(t);
  return e > -1 ? a.length - e - 1 : 0;
}, Fa = (a, t, e, s, l) => {
  const i = a.replace(l, "")[0] === "0", c = t.replace(l, "")[0] === "0";
  if (i && !c)
    return e - 1;
  if (c && s)
    return e + 1;
  let o = 0;
  for (let d = 0; d < e; d++)
    ke.test(a.charAt(d)) && o++;
  let f = 0;
  for (; o > 0 && t.length > f; )
    ke.test(t.charAt(f)) && o--, f++;
  return f;
}, Ta = (a, t, e) => {
  const s = { ...a }, { prevLooseValue: l } = s, i = e.numberSymbols(), c = es(t, e), o = String(s.currentLooseValue), f = String(l), d = new RegExp(`[^\\d\\${i.decimal}]`, "g"), m = new RegExp(`[^\\d\\${i.decimal}\\${i.group}]`, "g"), u = new RegExp(`[\\d\\${i.decimal}\\${i.group}]`), h = o.replace(d, ""), y = Pt(o, ke), M = y === -1 ? -1 : Ze(o, ke), D = o.indexOf(i.decimal), N = (o.substring(0, y) + o.substring(y, M).replace(m, "") + o.substring(M, o.length)).split("").filter((p) => c.indexOf(p) !== -1 || p.search(u) !== -1).join(""), L = e.formatNumber(Kn, t).replace(d, ""), S = L.indexOf(i.decimal), w = S > -1 ? L.length - S - 1 : 0, B = e.formatNumber(qn, t).replace(d, ""), O = B.indexOf(i.decimal), I = O > -1 ? B.length - O - 1 : 0, {
    positiveInfo: F,
    negativeInfo: _,
    zeroInfo: T,
    oneInfo: E
  } = Qn(t, e), V = [F, _, T, E], H = V.findIndex((p) => p.findIndex((v) => !!v) !== -1) !== 1, q = o.length > 0 && o.length < f.length, Z = typeof t == "string" && t[0] === "p" && o && o.indexOf(i.percentSign) === -1;
  if (!s.isPaste) {
    if (o === "")
      return s.eventValue = null, s.currentLooseValue = "", s;
    if (s.currentLooseValue === i.minusSign && e.formatNumber(-0, t) !== f)
      return s.eventValue = -0, s.currentLooseValue = ue(s.eventValue, t, e), Le(
        s,
        Nt(s.currentLooseValue, i),
        s.currentLooseValue,
        V
      ), s;
    if (s.currentLooseValue === i.decimal) {
      s.eventValue = 0;
      const k = ue(s.eventValue, t, e);
      if (I === 0 && w > 0) {
        const C = Ze(k, ke);
        s.currentLooseValue = k.substring(0, C) + i.decimal + k.substring(C);
      } else
        s.currentLooseValue = k;
      return Le(
        s,
        Nt(s.currentLooseValue, i) + 1,
        s.currentLooseValue,
        V
      ), s;
    }
    if (Yn(s, i)) {
      const k = e.parseNumber(l, t);
      s.eventValue = -(k !== null ? k : 0), s.currentLooseValue = ue(s.eventValue, t, e);
      const C = Pt(s.currentLooseValue, ke), P = Pt(f, ke);
      return Le(
        s,
        s.selectionEnd - 1 + (C - P),
        s.currentLooseValue,
        V
      ), s;
    }
    if (Zn(s, i))
      return s.eventValue = e.parseNumber(s.currentLooseValue, t), Le(
        s,
        s.selectionStart,
        s.currentLooseValue,
        V
      ), s;
    if (Jn(s, i))
      return Mt(s, t, V, e), s;
    if (Z)
      return s.eventValue = e.parseNumber(o, t) / 100, s.currentLooseValue = ue(s.eventValue, t, e), s;
    if (String(s.currentLooseValue).replace(/[^\d]/g, "").length > pn || h !== o && o && H && V.findIndex(([C, P]) => {
      const j = o.indexOf(C), J = o.indexOf(P), R = j === 0, b = J === o.length - P.length, W = j + C.length !== y && y !== -1 && o[j + C.length] !== i.decimal, K = J !== M && M !== -1 && o[J - 1] !== i.decimal;
      return C && P ? W || K ? !1 : R && b : C ? W ? !1 : R : P ? K ? !1 : b : !1;
    }) === -1)
      return Mt(s, t, V, e), s;
    if (h[h.length - 1] === i.decimal && w > 0)
      return s.eventValue = e.parseNumber(o, t), s.currentLooseValue = N, s;
    if (s.currentLooseValue && l && (c + i.decimal + i.group).split("").findIndex((C) => o.split("").filter((P) => P === C).length < f.split("").filter((P) => P === C).length && o.length + 1 === f.length ? !(C === i.decimal && Oa(f.replace(d, ""), i.decimal) === 0) : !1) > -1)
      return s.eventValue = e.parseNumber(a.prevLooseValue, t), s.currentLooseValue = a.prevLooseValue, s;
    const v = Oa(h, i.decimal), g = h[h.length - 1] === "0";
    if (q && g && v < I)
      return s.eventValue = e.parseNumber(s.currentLooseValue, t), s.currentLooseValue = ue(s.eventValue, t, e), s;
    if (v > 0) {
      const k = o.substring(0, D);
      if (g && (!k || f.indexOf(k) !== 0)) {
        s.eventValue = e.parseNumber(s.currentLooseValue, t);
        const C = ue(s.eventValue, t, e);
        return Le(
          s,
          Fa(o, C, s.selectionEnd, q, d),
          C,
          V
        ), s.currentLooseValue = C, s;
      }
      if (v > w) {
        const C = o.indexOf(i.decimal), P = o.substring(0, C) + o.substring(C, C + 1 + w) + o.substring(M, String(s.currentLooseValue).length);
        return s.eventValue = e.parseNumber(P, t), s.currentLooseValue = P, Le(s, s.selectionStart, P, V), s;
      }
      if (I !== w && v <= w && g)
        return s.eventValue = e.parseNumber(s.currentLooseValue, t), s.currentLooseValue = N, s;
      if (v < I)
        return s.eventValue = e.parseNumber(s.currentLooseValue, t), s.currentLooseValue = ue(s.eventValue, t, e), s;
    }
  }
  if (s.eventValue = e.parseNumber(s.currentLooseValue, t), Z && (s.eventValue = s.eventValue / 100), typeof s.eventValue == "number") {
    const p = ue(s.eventValue, t, e);
    o.length === 1 ? Le(s, Nt(p, i), p, V) : Le(
      s,
      Fa(o, p, s.selectionEnd, q, d),
      p,
      V
    ), s.currentLooseValue = p;
  } else
    s.currentLooseValue = ue(e.parseNumber(h), t, e);
  return s;
}, ts = "Please enter a valid value!", as = he(), ze = n.forwardRef((a, t) => {
  pe(me);
  const e = Re(as, a), s = Qe(), l = e.id || s, i = Mn(), c = _e(), o = n.useRef(null), f = n.useRef(), [d, m] = n.useState(!1), u = n.useRef(Na()), h = n.useRef(!1), y = n.useRef(), M = n.useRef(e.defaultValue), D = ue(
    u.current.focused && !e.disabled ? u.current.currentLooseValue : Vt(e.value, M.current),
    e.format,
    i
  );
  y.current = D;
  const [N] = qe(e.prefix), [L] = qe(e.suffix);
  n.useEffect(
    () => {
      o.current && o.current.setCustomValidity && o.current.setCustomValidity(
        I().valid ? "" : e.validationMessage || ts
      );
    }
  );
  const S = n.useCallback(
    () => {
      o.current && o.current.focus();
    },
    []
  ), w = n.useCallback(
    () => f.current !== void 0 ? f.current : Vt(e.value, M.current),
    [e.value]
  ), B = n.useCallback(
    () => e.name,
    [e.name]
  ), O = n.useCallback(
    () => e.required,
    [e.required]
  ), I = n.useCallback(
    () => {
      const R = e.validationMessage !== void 0, b = w(), W = e.valid !== void 0 ? e.valid : !u.current.valueIsOutOfRange && (!O() || b != null);
      return {
        customError: R,
        valid: W,
        valueMissing: b == null
      };
    },
    [e.validationMessage, e.valid, w, O]
  ), F = n.useCallback(
    () => e.validityStyles,
    [e.validityStyles]
  ), _ = n.useCallback(
    () => e,
    [e]
  ), T = n.useCallback(
    () => {
      const R = {
        element: o.current,
        focus: S
      };
      return Object.defineProperty(R, "name", { get: B }), Object.defineProperty(R, "value", { get: w }), Object.defineProperty(R, "validity", { get: I }), Object.defineProperty(R, "validityStyles", { get: F }), Object.defineProperty(R, "required", { get: O }), Object.defineProperty(R, "props", { get: _ }), R;
    },
    [B, w, I, F, O, S, _]
  );
  n.useImperativeHandle(t, T);
  const E = n.useCallback(
    () => ({
      eventValue: Vt(e.value, M.current),
      prevLooseValue: y.current,
      currentLooseValue: o.current.value,
      selectionStart: o.current.selectionStart,
      selectionEnd: o.current.selectionEnd,
      decimalSelect: !1,
      valueIsCorrected: !1,
      valueIsOutOfRange: !1,
      isPaste: h.current,
      focused: u.current.focused
    }),
    [e.value]
  ), V = n.useCallback(
    (R, b) => {
      if (e.disabled)
        return;
      f.current = b.eventValue, M.current = b.eventValue;
      const W = ue(Ge(b.eventValue, e.min, e.max), e.format, i), K = Ge(i.parseNumber(W, e.format), e.min, e.max);
      K !== b.eventValue && (b.valueIsOutOfRange = !0, b.eventValue = K, M.current = K), e.value !== b.eventValue && Q(
        e.onChange,
        R,
        T(),
        { value: b.eventValue }
      ), f.current = void 0, u.current = b, m((le) => !le);
    },
    [e.value, e.onChange, e.disabled, m, T]
  ), H = n.useCallback(
    (R) => {
      const b = E();
      h.current = !1, V(R, Ta(b, e.format, i));
    },
    [e.format, e.onChange, i, V, E]
  ), q = n.useCallback(
    (R) => {
      let b = E();
      const W = i.parseNumber(String(b.currentLooseValue), e.format);
      if (b.selectionEnd > b.selectionStart && b.selectionEnd - b.selectionStart === String(b.currentLooseValue).length) {
        const K = i.numberSymbols(), ee = K && R.key === K.minusSign, le = K && R.key === K.decimal;
        h.current = !ee && !le;
        return;
      }
      switch (R.keyCode) {
        case 38:
          Da(
            W,
            b,
            e.step,
            e.min,
            e.max,
            e.format,
            i
          );
          break;
        case 40:
          Ba(
            W,
            b,
            e.step,
            e.min,
            e.max,
            e.format,
            i
          );
          break;
        case 13: {
          if (e.rangeOnEnter === !1)
            return;
          const K = ue(Ge(W, e.min, e.max), e.format, i), ee = Ge(i.parseNumber(K, e.format), e.min, e.max);
          b.eventValue = ee, b.currentLooseValue = ue(ee, e.format, i), b.selectionStart = b.selectionEnd = b.currentLooseValue.length;
          break;
        }
        case 110: {
          const K = o.current, ee = i.numberSymbols();
          K && (b.currentLooseValue = b.currentLooseValue.slice(0, b.selectionStart) + ee.decimal + b.currentLooseValue.slice(b.selectionEnd), b.selectionStart = b.selectionEnd = b.selectionStart + 1, b = Ta(b, e.format, i));
          break;
        }
        default:
          return;
      }
      R.preventDefault(), V(R, b);
    },
    [e.format, e.min, e.max, e.step, e.onChange, e.rangeOnEnter, V, E]
  ), Z = n.useCallback(
    () => {
      h.current = !0;
    },
    []
  ), p = n.useCallback(
    (R) => {
      if (e.readOnly || e.disabled)
        return;
      const b = E();
      Da(
        i.parseNumber(String(b.currentLooseValue), e.format),
        b,
        e.step,
        e.min,
        e.max,
        e.format,
        i
      ), V(R, b);
    },
    [e.format, e.min, e.max, e.step, e.onChange, e.readOnly, e.disabled, V, E]
  ), v = n.useCallback(
    (R) => {
      if (e.readOnly || e.disabled)
        return;
      const b = E();
      Ba(
        i.parseNumber(String(b.currentLooseValue), e.format),
        b,
        e.step,
        e.min,
        e.max,
        e.format,
        i
      ), V(R, b);
    },
    [e.format, e.min, e.max, e.step, e.onChange, e.readOnly, e.disabled, V, E]
  ), g = n.useCallback(
    (R) => {
      const b = wa(document);
      !document || b !== o.current || !o.current || e.readOnly || e.disabled || (R.nativeEvent.deltaY < 0 && p(R), R.nativeEvent.deltaY > 0 && v(R));
    },
    [p, v, e.disabled, e.readOnly]
  ), k = n.useCallback(
    (R) => {
      u.current.currentLooseValue = y.current, u.current.focused = !0, Q(
        e.onFocus,
        R,
        T(),
        {}
      ), m((b) => !b);
    },
    [e.onFocus, m, T]
  ), C = n.useCallback(
    (R) => {
      u.current = Na(), Q(
        e.onBlur,
        R,
        T(),
        {}
      ), m((b) => !b);
    },
    [e.onBlur, m, T]
  ), P = n.useCallback(
    (R) => {
      if (document && o.current) {
        const b = wa(document);
        R.preventDefault(), b !== o.current && o.current.focus();
      }
    },
    []
  );
  n.useLayoutEffect(
    () => {
      o.current && o.current.type !== "number" && u.current.selectionStart !== void 0 && u.current.selectionEnd !== void 0 && (o.current.selectionStart = u.current.selectionStart, o.current.selectionEnd = u.current.selectionEnd, u.current.selectionStart = void 0, u.current.selectionEnd = void 0);
    },
    [d]
  );
  const j = !F() || I().valid, J = /* @__PURE__ */ n.createElement(
    "span",
    {
      dir: e.dir,
      style: e.label ? e.style : { width: e.width, ...e.style },
      className: G(
        "k-input",
        "k-numerictextbox",
        {
          [`k-input-${ne.sizeMap[e.size] || e.size}`]: e.size,
          [`k-input-${e.fillMode}`]: e.fillMode,
          [`k-rounded-${ne.roundedMap[e.rounded] || e.rounded}`]: e.rounded,
          "k-invalid": !j,
          "k-required": e.required,
          "k-disabled": e.disabled
        },
        e.className
      ),
      "aria-disabled": e.disabled ? "true" : void 0
    },
    /* @__PURE__ */ n.createElement(N, null),
    /* @__PURE__ */ n.createElement(
      "input",
      {
        role: "spinbutton",
        value: D === null ? "" : D,
        tabIndex: ie(e.tabIndex, e.disabled),
        accessKey: e.accessKey,
        disabled: e.disabled,
        title: e.title,
        "aria-disabled": e.disabled ? "true" : void 0,
        "aria-valuemin": e.min,
        "aria-valuemax": e.max,
        "aria-label": e.ariaLabel,
        "aria-labelledby": e.ariaLabelledBy,
        "aria-describedby": e.ariaDescribedBy,
        placeholder: e.placeholder,
        spellCheck: !1,
        autoComplete: "off",
        autoCorrect: "off",
        type: e.inputType || "tel",
        className: "k-input-inner",
        id: l,
        name: e.name,
        readOnly: e.readOnly,
        style: e.inputStyle,
        onChange: H,
        onFocus: k,
        onBlur: C,
        onKeyDown: q,
        onPaste: Z,
        onWheel: g,
        ref: o
      }
    ),
    /* @__PURE__ */ n.createElement(L, null),
    e.children,
    e.spinners && /* @__PURE__ */ n.createElement(
      "span",
      {
        className: "k-input-spinner k-spin-button",
        onMouseDown: P
      },
      /* @__PURE__ */ n.createElement(
        ge,
        {
          tabIndex: -1,
          type: "button",
          icon: "caret-alt-up",
          svgIcon: Tt,
          rounded: null,
          className: "k-spinner-increase",
          "aria-label": c.toLanguageString(Xe, $[Xe]),
          title: c.toLanguageString(Xe, $[Xe]),
          onClick: p
        }
      ),
      /* @__PURE__ */ n.createElement(
        ge,
        {
          tabIndex: -1,
          type: "button",
          icon: "caret-alt-down",
          svgIcon: ht,
          rounded: null,
          className: "k-spinner-decrease",
          "aria-label": c.toLanguageString(Ye, $[Ye]),
          title: c.toLanguageString(Ye, $[Ye]),
          onClick: v
        }
      )
    )
  );
  return e.label ? /* @__PURE__ */ n.createElement(
    ua,
    {
      label: e.label,
      editorId: l,
      editorValue: D === null ? "" : D,
      editorValid: j,
      editorDisabled: e.disabled,
      editorPlaceholder: e.placeholder,
      children: J,
      style: { width: e.width },
      dir: e.dir
    }
  ) : J;
});
ze.propTypes = {
  value: r.number,
  defaultValue: r.number,
  step: r.number,
  format: r.oneOfType([
    r.string,
    r.shape({
      style: r.oneOf(["decimal", "currency", "percent", "scientific", "accounting"]),
      currency: r.string,
      currencyDisplay: r.oneOf(["symbol", "code", "name"]),
      useGrouping: r.bool,
      minimumIntegerDigits: r.number,
      minimumFractionDigits: r.number,
      maximumFractionDigits: r.number
    })
  ]),
  width: r.oneOfType([
    r.string,
    r.number
  ]),
  tabIndex: r.number,
  accessKey: r.string,
  title: r.string,
  placeholder: r.string,
  min: r.number,
  max: r.number,
  spinners: r.bool,
  disabled: r.bool,
  readOnly: r.bool,
  dir: r.string,
  name: r.string,
  label: r.string,
  validationMessage: r.string,
  required: r.bool,
  id: r.string,
  rangeOnEnter: r.bool,
  ariaLabelledBy: r.string,
  ariaDescribedBy: r.string,
  ariaLabel: r.string,
  onChange: r.func,
  onFocus: r.func,
  onBlur: r.func,
  size: r.oneOf([null, "small", "medium", "large"]),
  rounded: r.oneOf([null, "small", "medium", "large", "full"]),
  fillMode: r.oneOf([null, "solid", "flat", "outline"])
};
ze.displayName = "KendoNumericTextBox";
ze.defaultProps = {
  prefix: (a) => null,
  suffix: (a) => null,
  step: 1,
  spinners: !0,
  disabled: !1,
  required: !1,
  validityStyles: !0,
  rangeOnEnter: !0,
  onChange: (a) => {
  },
  onFocus: (a) => {
  },
  onBlur: (a) => {
  },
  size: "medium",
  rounded: "medium",
  fillMode: "solid"
};
const ae = (a) => a != null, se = (a, t, e) => !ae(a) || isNaN(a) || a <= t ? t : a >= e ? e : a, Ne = (a, t, e = !0) => {
  if (["hex", "rgba"].indexOf(t) === -1)
    throw new Error(`Unsupported color output format '${t}'. The available options are 'hex' or 'rgba'.`);
  if (!ae(a))
    return;
  const l = mt(a.trim(), e);
  if (ae(l))
    return t === "hex" ? l.toCss() : l.toCssRgba();
}, Dt = (a, t = !0) => {
  const e = mt(a, t);
  return ae(e) ? e.toHSV() : {};
}, Ke = (a, t = !0) => {
  const e = mt(a, t);
  return ae(e) ? e.toBytes() : {};
}, fa = (a) => {
  const t = se(a.h, 0, 359.9), e = se(a.s, 0, 1), s = se(a.v, 0, 1), l = se(a.a, 0, 1);
  return an.fromHSV(t, e, s, l).toCssRgba();
}, rt = (a) => fa({ h: a, s: 1, v: 1, a: 1 }), ns = (a) => {
  const t = se(a.r, 0, 255), e = se(a.g, 0, 255), s = se(a.b, 0, 255), l = se(a.a, 0, 1);
  return an.fromBytes(t, e, s, l).toCssRgba();
}, za = (a, t) => {
  const e = se(a.r, 0, 255), s = se(a.g, 0, 255), l = se(a.b, 0, 255), i = se(a.a, 0, 1), c = se(t.r, 0, 255), o = se(t.g, 0, 255), f = se(t.b, 0, 255);
  return {
    r: Math.round((1 - i) * c + i * e),
    g: Math.round((1 - i) * o + i * s),
    b: Math.round((1 - i) * f + i * l)
  };
}, _a = (a) => {
  let t = [a.r || 0, a.g || 0, a.b || 0].map(function(e) {
    return e /= 255, e <= 0.03928 ? e / 12.92 : Math.pow((e + 0.055) / 1.055, 2.4);
  });
  return t[0] * 0.2126 + t[1] * 0.7152 + t[2] * 0.0722;
}, ss = (a, t) => {
  const e = Math.max(a, t), s = Math.min(a, t);
  return (e + 0.05) / (s + 0.05);
}, bn = (a, t) => ss(
  _a(za(a, t)),
  _a(za(t, { r: 0, g: 0, b: 0, a: 1 }))
), ra = class extends n.Component {
  constructor(a) {
    super(a), this._input = null, this.focus = () => {
      this._input && this._input.focus();
    }, this.isInvalid = (t) => {
      let e = !1;
      for (let s in t)
        t.hasOwnProperty(s) && (e = e || !!t[s]);
      return e;
    }, this.setValidity = () => {
      this._input && this._input.setCustomValidity && (this.validity.valid || !this.validityStyles ? this._input.classList.remove("k-invalid") : this._input.classList.add("k-invalid"), this._input.setCustomValidity(
        this.validity.valid ? "" : this.props.validationMessage || ""
      ));
    }, this.handleChange = (t) => {
      this.setState({
        value: t.target.value
      }), this.valueDuringOnChange = t.target.value, this.props.onChange && this.props.onChange.call(void 0, {
        syntheticEvent: t,
        nativeEvent: t.nativeEvent,
        value: t.target.value,
        target: this
      }), this.valueDuringOnChange = void 0;
    }, this.handleAutoFill = (t) => {
      if (t.animationName === "autoFillStart") {
        let e = t.target.parentNode;
        e && e.classList.contains("k-empty") && e.classList.remove("k-empty");
      }
    }, pe(me), this.state = {
      value: this.props.defaultValue || ra.defaultProps.defaultValue
    };
  }
  get _inputId() {
    return this.props.id;
  }
  /**
   * Gets the native input element of the Input component.
   */
  get element() {
    return this._input;
  }
  /**
   * Gets the value of the Input.
   */
  get value() {
    return this.valueDuringOnChange !== void 0 ? this.valueDuringOnChange : this.props.value !== void 0 ? this.props.value : this.state.value;
  }
  /**
   * Gets the `name` property of the Input.
   */
  get name() {
    return this.props.name;
  }
  /**
   * Represents the validity state into which the Input is set.
   */
  get validity() {
    const a = {
      badInput: this._input ? this._input.validity.badInput : !1,
      patternMismatch: this._input ? this._input.validity.patternMismatch : !1,
      rangeOverflow: this._input ? this._input.validity.rangeOverflow : !1,
      rangeUnderflow: this._input ? this._input.validity.rangeUnderflow : !1,
      stepMismatch: this._input ? this._input.validity.stepMismatch : !1,
      tooLong: this._input ? this._input.validity.tooLong : !1,
      typeMismatch: this._input ? this._input.validity.typeMismatch : !1,
      valueMissing: this._input ? this._input.validity.valueMissing : !1
    };
    return {
      ...a,
      customError: this.props.validationMessage !== void 0,
      valid: this.props.valid !== void 0 ? this.props.valid : this._input ? !this.isInvalid(a) : !0
    };
  }
  /**
   * @hidden
   */
  get validityStyles() {
    return this.props.validityStyles !== void 0 ? this.props.validityStyles : ra.defaultProps.validityStyles;
  }
  /**
   * @hidden
   */
  componentDidMount() {
    this.forceUpdate();
  }
  /**
   * @hidden
   */
  componentDidUpdate() {
    this.setValidity();
  }
  /**
   * @hidden
   */
  render() {
    const {
      className: a,
      label: t,
      labelClassName: e,
      id: s,
      validationMessage: l,
      defaultValue: i,
      valid: c,
      // Removed to support direct use in Form Field component
      visited: o,
      touched: f,
      modified: d,
      ariaLabelledBy: m,
      ariaDescribedBy: u,
      validityStyles: h,
      style: y,
      ariaLabel: M,
      ...D
    } = this.props, N = s || this._inputId, L = !this.validityStyles || this.validity.valid, S = G(a, "k-input k-input-md k-rounded-md k-input-solid"), w = /* @__PURE__ */ n.createElement(
      "input",
      {
        "aria-labelledby": m,
        "aria-describedby": u,
        "aria-disabled": this.props.disabled || void 0,
        "aria-invalid": !L || void 0,
        "aria-label": M || void 0,
        ...D,
        style: t ? void 0 : y,
        value: this.value,
        id: N,
        className: S,
        onChange: this.handleChange,
        onAnimationStart: this.handleAutoFill,
        ref: (B) => {
          this._input = B;
        }
      }
    );
    return t ? /* @__PURE__ */ n.createElement(
      ua,
      {
        label: t,
        labelClassName: e,
        editorId: N,
        editorValue: String(this.value),
        editorValid: L,
        editorDisabled: D.disabled,
        editorPlaceholder: D.placeholder,
        children: w,
        style: y,
        dir: D.dir
      }
    ) : w;
  }
};
let gt = ra;
gt.displayName = "Input";
gt.propTypes = {
  label: r.string,
  labelClassName: r.string,
  validationMessage: r.string,
  required: r.bool,
  validate: r.bool,
  id: r.string,
  ariaLabelledBy: r.string,
  ariaDescribedBy: r.string,
  ariaLabel: r.string
};
gt.defaultProps = {
  defaultValue: "",
  required: !1,
  validityStyles: !0
};
const rs = he(), vn = et(Ue(rs, gt));
vn.displayName = "KendoReactInput";
class is extends n.Component {
  constructor(t) {
    super(t), this.onChange = (e) => {
      const s = e.target.value, l = Ne(s, "rgba");
      this.setState({ hex: s }), ae(l) && this.props.onHexChange(s, l, e);
    }, this.onBlur = () => {
      ae(Ne(this.state.hex, "rgba")) || this.setState({ hex: this.state.originalHex });
    }, this.state = { hex: this.props.hex, originalHex: this.props.hex };
  }
  render() {
    return /* @__PURE__ */ n.createElement(
      vn,
      {
        value: this.state.hex,
        onChange: this.onChange,
        onBlur: this.onBlur,
        disabled: this.props.disabled
      }
    );
  }
  static getDerivedStateFromProps(t, e) {
    return t.hex !== e.originalHex ? { hex: t.hex, originalHex: t.hex } : null;
  }
}
const Be = ["rgba", "rgb", "hex"];
class ha extends n.Component {
  constructor(t) {
    super(t), this.onRgbaRChange = (e) => {
      this.dispatchRgbaChange({ r: e.value }, e);
    }, this.onRgbaGChange = (e) => {
      this.dispatchRgbaChange({ g: e.value }, e);
    }, this.onRgbaBChange = (e) => {
      this.dispatchRgbaChange({ b: e.value }, e);
    }, this.onRgbaAChange = (e) => {
      this.dispatchRgbaChange({ a: e.value }, e);
    }, this.state = { inputMode: t.defaultInputMode || Be[1] };
  }
  render() {
    const t = Je(this), e = t.toLanguageString(Fe, $[ln]), s = t.toLanguageString(Fe, $[Fe]), l = t.toLanguageString(Fe, $[nn]), i = t.toLanguageString(Fe, $[sn]), c = t.toLanguageString(Fe, $[rn]), o = t.toLanguageString(Wt, $[Wt]);
    return /* @__PURE__ */ n.createElement("div", { className: "k-colorgradient-inputs k-hstack" }, /* @__PURE__ */ n.createElement("div", { className: "k-vstack" }, /* @__PURE__ */ n.createElement(
      ge,
      {
        "aria-label": o,
        fillMode: "flat",
        icon: "caret-alt-expand",
        svgIcon: On,
        className: "k-colorgradient-toggle-mode k-icon-button",
        onClick: this.onToggleModeChange.bind(this)
      }
    )), this.state.inputMode === "hex" && /* @__PURE__ */ n.createElement("div", { className: "k-vstack k-flex-1" }, /* @__PURE__ */ n.createElement("span", { className: "k-hex-value k-textbox k-input" }, /* @__PURE__ */ n.createElement(
      is,
      {
        hex: this.props.hex,
        onHexChange: this.props.onHexChange,
        disabled: this.props.disabled
      }
    )), /* @__PURE__ */ n.createElement(We, { className: "k-colorgradient-input-label" }, e)), (this.state.inputMode === "rgb" || this.state.inputMode === "rgba") && /* @__PURE__ */ n.createElement(n.Fragment, null, /* @__PURE__ */ n.createElement("div", { className: "k-vstack" }, /* @__PURE__ */ n.createElement(
      ze,
      {
        inputType: "number",
        value: this.props.rgba.r,
        ariaLabel: String(this.props.rgba.r),
        min: 0,
        max: 255,
        spinners: !1,
        format: "n",
        onChange: this.onRgbaRChange,
        disabled: this.props.disabled
      }
    ), /* @__PURE__ */ n.createElement(We, { className: "k-colorgradient-input-label" }, s)), /* @__PURE__ */ n.createElement("div", { className: "k-vstack" }, /* @__PURE__ */ n.createElement(
      ze,
      {
        inputType: "number",
        value: this.props.rgba.g,
        ariaLabel: String(this.props.rgba.g),
        min: 0,
        max: 255,
        spinners: !1,
        format: "n",
        onChange: this.onRgbaGChange,
        disabled: this.props.disabled
      }
    ), /* @__PURE__ */ n.createElement(We, { className: "k-colorgradient-input-label" }, l)), /* @__PURE__ */ n.createElement("div", { className: "k-vstack" }, /* @__PURE__ */ n.createElement(
      ze,
      {
        inputType: "number",
        value: this.props.rgba.b,
        ariaLabel: String(this.props.rgba.b),
        min: 0,
        max: 255,
        spinners: !1,
        format: "n",
        onChange: this.onRgbaBChange,
        disabled: this.props.disabled
      }
    ), /* @__PURE__ */ n.createElement(We, { className: "k-colorgradient-input-label" }, i))), this.state.inputMode === "rgba" && /* @__PURE__ */ n.createElement("div", { className: "k-vstack" }, this.props.opacity && /* @__PURE__ */ n.createElement(
      ze,
      {
        inputType: "number",
        value: this.props.rgba.a,
        ariaLabel: String(this.props.rgba.a),
        min: 0,
        max: 1,
        step: 0.01,
        spinners: !1,
        format: "n2",
        onChange: this.onRgbaAChange,
        disabled: this.props.disabled
      }
    ), this.props.opacity && /* @__PURE__ */ n.createElement(We, { className: "k-colorgradient-input-label" }, c)));
  }
  dispatchRgbaChange(t, e) {
    let s = { ...this.props.rgba };
    t.r !== void 0 && (s.r = t.r), t.g !== void 0 && (s.g = t.g), t.b !== void 0 && (s.b = t.b), t.a !== void 0 && (s.a = t.a), this.props.onRgbaChange(s, e);
  }
  onToggleModeChange() {
    const t = Be.length - 1 === Be.indexOf(this.state.inputMode) ? 0 : Be.indexOf(this.state.inputMode) + 1;
    if (this.props.opacity)
      this.setState({ inputMode: Be[t] });
    else {
      const e = Be[t] === "rgba" ? t + 1 : t;
      this.setState({ inputMode: Be[e] });
    }
  }
}
Nn(ha);
da(ha);
const kn = "data-slider-label", Rr = (a) => {
  const t = n.useRef(null), e = Ae(t), s = a.vertical ? { bottom: `${a.position}%` } : { [e === "rtl" ? "right" : "left"]: `${a.position}%` }, l = a.vertical ? "k-tick-vertical" : "k-tick-horizontal";
  return /* @__PURE__ */ n.createElement(
    "li",
    {
      ref: t,
      className: `k-tick k-tick-large ${l}`,
      title: a.title,
      style: {
        zIndex: 1,
        position: "absolute",
        ...s
      }
    },
    a.children && /* @__PURE__ */ n.createElement(
      "span",
      {
        [kn]: !0,
        className: "k-label",
        onClick: a.onClick
      },
      a.children
    )
  );
};
class bt extends n.Component {
  constructor(t) {
    super(t), this.state = {
      value: this.props.defaultValue === void 0 ? this.props.min : this.props.defaultValue,
      focused: !1,
      dir: this.props.dir
    }, this._sliderTrack = null, this._element = null, this.buttons = (e) => {
      if (!e.enabled)
        return e.children;
      const s = this.state.dir === "rtl" ? this.props.vertical ? Tt : Ia : this.props.vertical ? Tt : La, l = this.state.dir === "rtl" ? this.props.vertical ? ht : La : this.props.vertical ? ht : Ia, i = this.state.dir === "rtl" ? this.props.vertical ? "caret-alt-up" : "caret-alt-left" : this.props.vertical ? "caret-alt-up" : "caret-alt-right", c = this.state.dir === "rtl" ? this.props.vertical ? "caret-alt-down" : "caret-alt-right" : this.props.vertical ? "caret-alt-down" : "caret-alt-left";
      return /* @__PURE__ */ n.createElement(n.Fragment, null, /* @__PURE__ */ n.createElement(
        ge,
        {
          className: "k-button-decrease",
          rounded: "full",
          icon: c,
          svgIcon: l,
          title: e.decrementTitle,
          onClick: e.decrement
        }
      ), e.children, /* @__PURE__ */ n.createElement(
        ge,
        {
          className: "k-button-increase",
          rounded: "full",
          icon: i,
          svgIcon: s,
          title: e.incrementTitle,
          onClick: e.increment
        }
      ));
    }, this.focus = () => {
      this._element && this._element.focus();
    }, this.isLabel = (e) => {
      let s = e;
      for (; s; ) {
        if (s.getAttribute(kn))
          return !0;
        s = s.parentElement;
      }
      return !1;
    }, this.onFocus = () => {
      this.setState({ focused: !0 });
    }, this.onBlur = () => {
      this.setState({ focused: !1 });
    }, this.onKeyDown = (e) => {
      let s;
      e.keyCode === z.left || e.keyCode === z.down ? s = this.state.value - (this.props.step || 0) : e.keyCode === z.right || e.keyCode === z.up ? s = this.state.value + (this.props.step || 0) : e.keyCode === z.home ? s = this.props.min : e.keyCode === z.end && (s = this.props.max), s !== void 0 && (e.preventDefault(), this.change(e, s));
    }, this.decrement = (e) => {
      e.preventDefault(), this.change(e, this.state.value - (this.props.step || 0));
    }, this.increment = (e) => {
      e.preventDefault(), this.change(e, this.state.value + (this.props.step || 0));
    }, this.dragStart = (e) => {
      this.isLabel(e.event.originalEvent.target) || (e.event.isTouch && e.event.originalEvent.preventDefault(), this.drag(e));
    }, this.dragOver = (e) => {
      e.event.originalEvent.preventDefault(), this.drag(e);
    }, this.drag = (e) => {
      const s = e.element.getBoundingClientRect(), l = this.props.vertical ? s.bottom - e.event.clientY : this.state.dir === "rtl" ? s.right - e.event.clientX : e.event.clientX - s.left, i = this.props.vertical ? s.height : s.width, c = l / i;
      this.change(e, this.props.min + c * (this.props.max - this.props.min));
    }, pe(me);
  }
  /**
   * @hidden
   */
  static getDerivedStateFromProps(t, e) {
    const s = t.value !== void 0 ? t.value : e.value, { min: l, max: i } = t;
    return s === void 0 ? null : { value: Math.min(Math.max(s, l), i) };
  }
  /**
   * @hidden
   */
  componentDidMount() {
    if (!this.state.dir && window && this._element) {
      const t = window.getComputedStyle(this._element).direction;
      t && this.setState({ dir: t });
    }
  }
  /**
   * @hidden
   */
  render() {
    const t = Je(this), e = (this.state.value - this.props.min) / (this.props.max - this.props.min) * 100, s = this.props.vertical ? { marginTop: "0.5rem", marginBottom: "0.5rem" } : { marginLeft: "0.5rem", marginRight: "0.5rem" }, l = this.props.vertical ? { paddingTop: 0, height: "100%" } : {};
    return /* @__PURE__ */ n.createElement(
      "div",
      {
        ref: (i) => this._element = i,
        dir: this.state.dir,
        id: this.props.id,
        style: { gap: 0, ...this.props.style },
        onFocus: this.onFocus,
        onBlur: this.onBlur,
        onKeyDown: this.onKeyDown,
        className: G(
          "k-slider",
          {
            "k-focus": this.state.focused,
            "k-disabled": this.props.disabled,
            "k-slider-horizontal": !this.props.vertical,
            "k-slider-vertical": this.props.vertical
          },
          this.props.className
        )
      },
      /* @__PURE__ */ n.createElement(
        this.buttons,
        {
          enabled: this.props.buttons,
          decrement: this.decrement,
          increment: this.increment,
          incrementTitle: t.toLanguageString(_t, $[_t]),
          decrementTitle: t.toLanguageString(At, $[At])
        },
        /* @__PURE__ */ n.createElement(en, { onDrag: this.dragOver, onPress: this.dragStart }, /* @__PURE__ */ n.createElement(
          "div",
          {
            className: "k-slider-track-wrap",
            style: {
              flexGrow: 1,
              position: "relative",
              touchAction: "none",
              ...s
            }
          },
          this.props.children && /* @__PURE__ */ n.createElement(
            "ul",
            {
              className: "k-reset k-slider-items",
              style: { margin: 0, ...l }
            },
            n.Children.map(this.props.children, (i) => i && n.cloneElement(
              i,
              {
                position: 100 * (i.props.position - this.props.min) / (this.props.max - this.props.min),
                vertical: this.props.vertical
              },
              i.props.children
            ))
          ),
          /* @__PURE__ */ n.createElement(
            "div",
            {
              className: "k-slider-track",
              style: this.props.vertical ? { bottom: 0, height: "100%" } : { [this.state.dir === "rtl" ? "right" : "left"]: 0, width: "100%" },
              ref: (i) => this._sliderTrack = i
            },
            /* @__PURE__ */ n.createElement(
              "div",
              {
                className: "k-slider-selection",
                style: this.props.vertical ? { height: e + "%" } : { width: e + "%" }
              }
            ),
            /* @__PURE__ */ n.createElement(
              "span",
              {
                role: "slider",
                "aria-valuemin": this.props.min,
                "aria-valuemax": this.props.max,
                "aria-valuenow": this.state.value,
                "aria-valuetext": String(this.state.value),
                "aria-orientation": this.props.vertical ? "vertical" : void 0,
                "aria-disabled": this.props.disabled ? "true" : void 0,
                "aria-labelledby": this.props.ariaLabelledBy,
                "aria-describedby": this.props.ariaDescribedBy,
                "aria-label": this.props.ariaLabel,
                tabIndex: ie(this.props.tabIndex, this.props.disabled, void 0),
                className: "k-draghandle",
                title: t.toLanguageString(Te, $[Te]),
                style: this.props.vertical ? { bottom: "calc(" + e + "%)", zIndex: 1 } : this.state.dir === "rtl" ? { right: "calc(" + e + "% - 13px)", zIndex: 1 } : { left: "calc(" + e + "%)", zIndex: 1 }
              }
            )
          )
        ))
      )
    );
  }
  /**
   * @hidden
   */
  get sliderTrack() {
    return this._sliderTrack;
  }
  change(t, e) {
    e = Math.min(Math.max(e, this.props.min), this.props.max), this.setState({ value: e }), Q(this.props.onChange, t, this, { value: e });
  }
}
bt.displayName = "Slider";
bt.propTypes = {
  min: r.number.isRequired,
  max: r.number.isRequired,
  value: r.number,
  vertical: r.bool,
  id: r.string,
  ariaLabelledBy: r.string,
  ariaDescribedBy: r.string,
  ariaLabel: r.string
  // TODO: validation when buttons is set to true, but no step is provided
};
const ls = he(), ia = Ue(ls, bt);
ia.displayName = "KendoReactSlider";
da(bt);
const $e = {};
function os(a, t, e) {
  $e[a] = { value: t, hsva: e };
}
function cs(a, t, e) {
  $e[a] = { value: t, rgba: e };
}
function ds(a, t, e) {
  $e[a] = { value: t, hex: e };
}
function us(a) {
  delete $e[a];
}
function fs(a, t) {
  if (a) {
    const e = $e[a];
    return e && e.value === t ? e.hex : void 0;
  } else
    return;
}
function hs(a, t) {
  if (a) {
    const e = $e[a];
    return e && e.value === t ? e.hsva : void 0;
  } else
    return;
}
function ps(a, t) {
  if (a) {
    const e = $e[a];
    return e && e.value === t ? e.rgba : void 0;
  } else
    return;
}
class yn extends n.Component {
  render() {
    const t = Je(this), e = t.toLanguageString($t, $[$t]), s = t.toLanguageString(Ht, $[Ht]), l = t.toLanguageString(Gt, $[Gt]), i = t.toLanguageString(Kt, $[Kt]), c = t.toLanguageString(qt, $[qt]), o = bn(this.props.rgba, this.props.bgColor), f = 4.5.toFixed(1), d = 7 .toFixed(1), m = `${e}: ${o.toFixed(2)}`, u = `${s}: ${f}`, h = `${l}: ${d}`, y = /* @__PURE__ */ n.createElement("span", { className: "k-contrast-validation k-text-success" }, i, " ", /* @__PURE__ */ n.createElement(fe, { name: "check", icon: Rt })), M = /* @__PURE__ */ n.createElement("span", { className: "k-contrast-validation k-text-error" }, c, " ", /* @__PURE__ */ n.createElement(fe, { name: "x", icon: zt }));
    return /* @__PURE__ */ n.createElement("div", { className: "k-vbox k-colorgradient-color-contrast" }, /* @__PURE__ */ n.createElement("div", { className: "k-contrast-ratio" }, /* @__PURE__ */ n.createElement("span", { className: "k-contrast-ratio-text" }, m), o >= 4.5 ? /* @__PURE__ */ n.createElement("span", { className: "k-contrast-validation k-text-success" }, /* @__PURE__ */ n.createElement(fe, { name: "check", icon: Rt }), o >= 7 && /* @__PURE__ */ n.createElement(fe, { name: "check", icon: Rt })) : /* @__PURE__ */ n.createElement("span", { className: "k-contrast-validation k-text-error" }, /* @__PURE__ */ n.createElement(fe, { name: "x", icon: zt }))), /* @__PURE__ */ n.createElement("div", null, /* @__PURE__ */ n.createElement("span", null, u), o >= 4.5 ? y : M), /* @__PURE__ */ n.createElement("div", null, /* @__PURE__ */ n.createElement("span", null, h), o >= 7 ? y : M));
  }
}
da(yn);
const it = (a, t) => a.length === 0 ? "" : `<path d="${a.reduce(
  (s, l, i, c) => i === 0 ? (
    // if first point
    `M ${l[0]},${l[1]}`
  ) : (
    // else
    `${s} ${t(l, i, c)}`
  ),
  ""
)}" fill="none" stroke="white" stroke-width="1"/>`, ms = (a, t) => {
  const e = t[0] - a[0], s = t[1] - a[1];
  return {
    length: Math.sqrt(Math.pow(e, 2) + Math.pow(s, 2)),
    angle: Math.atan2(s, e)
  };
}, gs = (a) => (t, e, s, l) => {
  const i = e || t, c = s || t, o = 0.1, f = a(i, c), d = f.angle + (l ? Math.PI : 0), m = f.length * o, u = t[0] + Math.cos(d) * m, h = t[1] + Math.sin(d) * m;
  return [u, h];
}, bs = (a) => (t, e, s) => {
  const [l, i] = a(s[e - 1], s[e - 2], t), [c, o] = a(t, s[e - 1], s[e + 1], !0);
  return `C ${l},${i} ${c},${o} ${t[0]},${t[1]}`;
}, Aa = 4.5, $a = 7, lt = 16;
class vs extends n.Component {
  renderSvgCurveLine() {
    const t = this.props.metrics, e = (i, c, o, f, d) => {
      const m = (o + f) / 2, u = Object.assign({}, this.props.hsva, { s: c / t.width, v: 1 - m / t.height }), h = bn(Ke(fa(u)), Ke(this.props.backgroundColor || ""));
      return o + 0.5 > f ? h < i + 1 && h > i - 1 ? m : null : d(h, i) ? e(i, c, o, f - (f - o) / 2, d) : e(i, c, o + (f - o) / 2, f, d);
    }, s = (i, c, o = !1) => {
      const f = [];
      for (let d = 0; d <= t.width; d += t.width / c) {
        const m = e(i, d, 0, t.height, o ? (u, h) => u < h : (u, h) => u > h);
        m !== null && f.push([d, m]);
      }
      return f;
    }, l = bs(gs(ms));
    return it(s(Aa, lt), l) + it(s(Aa, lt, !0), l) + it(s($a, lt), l) + it(s($a, lt, !0), l);
  }
  shouldComponentUpdate(t) {
    return !(t.hsva.h === this.props.hsva.h && t.hsva.a === this.props.hsva.a && this.props.backgroundColor === t.backgroundColor);
  }
  render() {
    return /* @__PURE__ */ n.createElement(
      "svg",
      {
        xmlns: "http://www.w3.org/2000/svg",
        className: "k-color-contrast-svg",
        dangerouslySetInnerHTML: { __html: this.renderSvgCurveLine() },
        style: {
          position: "absolute",
          overflow: "visible",
          pointerEvents: "none",
          left: 0,
          top: 0,
          zIndex: 3
        }
      }
    );
  }
}
const ks = "rgba", Ha = "rgba(255, 255, 255, 1)", la = class extends n.Component {
  constructor(a) {
    super(a), this.wrapper = null, this.onHexChange = (e, s, l) => {
      if (this.isUncontrolled) {
        const i = Dt(s);
        this.setState({ hsva: i, backgroundColor: rt(i.h), rgba: Ke(s), hex: e });
      } else
        ds(this.state.guid, s, e);
      this.dispatchChangeEvent(s, l, l.nativeEvent);
    }, this.onRgbaChange = (e, s) => {
      const l = ns(e);
      if (this.isUncontrolled) {
        const i = Dt(l), c = Ne(l, "hex");
        this.setState({ hsva: i, backgroundColor: rt(i.h), rgba: e, hex: c });
      } else
        cs(this.state.guid, l, e);
      this.dispatchChangeEvent(l, s.syntheticEvent, s.nativeEvent);
    }, this.onAlphaSliderChange = (e) => {
      this.handleHsvaChange(
        Object.assign({}, this.state.hsva, { a: e.value / 100 }),
        e.syntheticEvent,
        e.nativeEvent
      );
    }, this.onHueSliderChange = (e) => {
      this.handleHsvaChange(
        Object.assign({}, this.state.hsva, { h: e.value }),
        e.syntheticEvent,
        e.nativeEvent
      );
    }, this.onDrag = (e) => {
      this.gradientWrapper.classList.add("k-dragging"), this.changePosition(e.event);
    }, this.onRelease = () => {
      this.gradientWrapper.classList.remove("k-dragging");
    }, this.onGradientWrapperClick = (e) => {
      this.changePosition(e);
    }, this.changePosition = (e) => {
      const s = this.getGradientRectMetrics(), l = e.clientX - s.left, i = e.clientY - s.top, c = se(l, 0, s.width), o = se(i, 0, s.height), f = Object.assign(
        {},
        this.state.hsva,
        { s: c / s.width, v: 1 - o / s.height }
      );
      this.handleHsvaChange(f, e, e.nativeEvent);
    }, this.onFocus = (e) => {
      this.props.onFocus && this.props.onFocus.call(
        void 0,
        { nativeEvent: e, target: this }
      );
    }, this.focus = () => {
      tn(this.wrapper);
    }, pe(me);
    const t = a.value || a.defaultValue || Ne(Ha, ks);
    this.state = Object.assign({}, la.getStateFromValue(t), { isFirstRender: !0, guid: this.props.id });
  }
  /**
   * @hidden
   */
  static getDerivedStateFromProps(a, t) {
    return a.value && !t.isFirstRender ? la.getStateFromValue(a.value, t.guid) : null;
  }
  /**
   * @hidden
   */
  componentDidMount() {
    this.setAlphaSliderBackground(this.state.backgroundColor), this.state.isFirstRender && this.setState({ isFirstRender: !1 });
  }
  /**
   * @hidden
   */
  componentWillUnmount() {
    us(this.state.guid);
  }
  /**
   * @hidden
   */
  componentDidUpdate(a, t) {
    t.backgroundColor !== this.state.backgroundColor && this.setAlphaSliderBackground(this.state.backgroundColor);
  }
  /**
   * @hidden
   */
  renderRectangleDragHandle() {
    let a = {};
    if (!this.state.isFirstRender) {
      const t = this.getGradientRectMetrics(), e = (1 - this.state.hsva.v) * t.height, s = this.state.hsva.s * t.width;
      a.top = `${e}px`, a.left = `${s}px`;
    }
    return /* @__PURE__ */ n.createElement(
      "div",
      {
        role: "slider",
        tabIndex: ie(this.props.tabIndex, this.props.disabled),
        "aria-valuetext": this.props.ariaValueText,
        "aria-valuenow": parseInt(this.state.hex.substring(1), 16),
        "aria-label": this.props.ariaLabelHSV,
        "aria-orientation": void 0,
        "aria-disabled": this.props.disabled ? "true" : void 0,
        className: "k-hsv-draghandle k-draghandle",
        style: a
      }
    );
  }
  /**
   * @hidden
   */
  handleHsvaChange(a, t, e) {
    const s = fa(a);
    if (this.isUncontrolled) {
      const l = Ne(s, "hex");
      this.setState({ hsva: a, backgroundColor: rt(a.h), rgba: Ke(s), hex: l });
    } else
      os(this.state.guid, s, a);
    this.dispatchChangeEvent(s, t, e);
  }
  /**
   * @hidden
   */
  dispatchChangeEvent(a, t, e) {
    this.props.onChange && this.props.onChange.call(
      void 0,
      { syntheticEvent: t, nativeEvent: e, target: this, value: a }
    );
  }
  /**
   * @hidden
   */
  static getStateFromValue(a, t) {
    ae(Ne(a, "hex")) || (a = Ha);
    const e = hs(t, a) || Dt(a), s = ps(t, a) || Ke(a), l = fs(t, a) || Ne(a, "hex"), i = rt(e.h);
    return { hsva: e, backgroundColor: i, rgba: s, hex: l };
  }
  /**
   * @hidden
   */
  setAlphaSliderBackground(a) {
    this.props.opacity && this.alphaSlider && this.alphaSlider.sliderTrack && (this.alphaSlider.sliderTrack.style.background = `linear-gradient(to top, transparent, ${a})`);
  }
  /**
   * @hidden
   */
  get isUncontrolled() {
    return this.props.value === void 0;
  }
  /**
   * @hidden
   */
  getGradientRectMetrics() {
    return this.gradientWrapper.getBoundingClientRect();
  }
  /**
   * @hidden
   */
  render() {
    const a = Je(this), t = G("k-colorgradient", { "k-disabled": this.props.disabled }, this.props.className);
    return /* @__PURE__ */ n.createElement(
      "div",
      {
        id: this.props.id,
        role: this.props.role,
        className: t,
        "aria-disabled": this.props.disabled ? "true" : void 0,
        style: this.props.style,
        ref: (e) => this.wrapper = e,
        tabIndex: ie(this.props.tabIndex, this.props.disabled),
        "aria-label": this.props.ariaLabel,
        "aria-labelledby": this.props.ariaLabelledBy,
        "aria-describedby": this.props.ariaDescribedBy,
        onFocus: this.onFocus
      },
      /* @__PURE__ */ n.createElement("div", { className: "k-colorgradient-canvas k-hstack" }, /* @__PURE__ */ n.createElement("div", { className: "k-hsv-rectangle", style: { background: this.state.backgroundColor } }, /* @__PURE__ */ n.createElement(
        en,
        {
          onDrag: this.onDrag,
          onRelease: this.onRelease,
          ref: (e) => this.gradientWrapper = e ? e.element : void 0
        },
        /* @__PURE__ */ n.createElement(
          "div",
          {
            className: "k-hsv-gradient",
            style: { touchAction: "none" },
            onClick: this.onGradientWrapperClick
          },
          this.renderRectangleDragHandle()
        )
      ), this.props.backgroundColor && !this.state.isFirstRender && /* @__PURE__ */ n.createElement(
        vs,
        {
          metrics: this.gradientWrapper ? this.getGradientRectMetrics() : void 0,
          hsva: this.state.hsva,
          backgroundColor: this.props.backgroundColor
        }
      )), /* @__PURE__ */ n.createElement("div", { className: "k-hsv-controls k-hstack" }, /* @__PURE__ */ n.createElement(
        ia,
        {
          value: this.state.hsva.h,
          buttons: !1,
          vertical: !0,
          min: 0,
          max: 360,
          step: 5,
          onChange: this.onHueSliderChange,
          className: "k-hue-slider k-colorgradient-slider",
          disabled: this.props.disabled,
          ariaLabel: a.toLanguageString(Ut, $[Ut])
        }
      ), this.props.opacity && /* @__PURE__ */ n.createElement(
        ia,
        {
          value: ae(this.state.hsva.a) ? this.state.hsva.a * 100 : 100,
          buttons: !1,
          vertical: !0,
          min: 0,
          max: 100,
          step: 1,
          ariaLabel: a.toLanguageString(jt, $[jt]),
          onChange: this.onAlphaSliderChange,
          className: "k-alpha-slider k-colorgradient-slider",
          disabled: this.props.disabled,
          ref: (e) => this.alphaSlider = e
        }
      ))),
      /* @__PURE__ */ n.createElement(
        ha,
        {
          rgba: this.state.rgba,
          onRgbaChange: this.onRgbaChange,
          hex: this.state.hex,
          onHexChange: this.onHexChange,
          opacity: this.props.opacity,
          disabled: this.props.disabled,
          defaultInputMode: this.props.format
        }
      ),
      this.props.backgroundColor && /* @__PURE__ */ n.createElement(
        yn,
        {
          bgColor: Ke(this.props.backgroundColor),
          rgba: this.state.rgba
        }
      )
    );
  }
};
let vt = la;
vt.displayName = "ColorGradient";
vt.propTypes = {
  defaultValue: r.string,
  value: r.string,
  onChange: r.func,
  onFocus: r.func,
  opacity: r.bool,
  backgroundColor: r.string,
  format: r.any,
  disabled: r.bool,
  style: r.any,
  id: r.string,
  role: r.string,
  ariaLabel: r.string,
  ariaLabelledBy: r.string,
  ariaDescribedBy: r.string,
  className: r.string
};
vt.defaultProps = {
  opacity: !0,
  role: "textbox",
  format: "rgb"
};
const ys = he(), pa = et(Ue(ys, vt));
pa.displayName = "KendoReactColorGradient";
class Cs {
  constructor() {
    this.colorRows = [];
  }
  setColorMatrix(t, e) {
    if (this.colorRows = [], !!(ae(t) && t.length)) {
      e = e || t.length;
      for (let s = 0; s < t.length; s += e) {
        const l = t.slice(s, e + s);
        this.colorRows.push(l);
      }
    }
  }
  getCellCoordsFor(t) {
    if (!ae(t))
      return;
    const e = t && mt(t, !0), s = [t];
    ae(e) && s.push(e.toCss(), e.toCssRgba());
    for (let l = 0; l < this.colorRows.length; l++)
      for (let i = 0; i < this.colorRows[l].length; i++)
        if (s.some((c) => c === this.colorRows[l][i]))
          return { row: l, col: i };
  }
  getColorAt(t) {
    if (ae(t) && ae(this.colorRows[t.row]))
      return this.colorRows[t.row][t.col];
  }
  getNextCell(t, e, s) {
    if (!(ae(t) && ae(t.row) && ae(t.col)))
      return { row: 0, col: 0 };
    const l = this.clampIndex(t.row + s, this.colorRows.length - 1), i = this.clampIndex(t.col + e, this.colorRows[l].length - 1);
    return { row: l, col: i };
  }
  clampIndex(t, e) {
    return t < 0 ? 0 : t > e ? e : t;
  }
}
const xs = {
  basic: {
    colors: ["#000000", "#7f7f7f", "#880015", "#ed1c24", "#ff7f27", "#fff200", "#22b14c", "#00a2e8", "#3f48cc", "#a349a4", " ffffff", "#c3c3c3", "#b97a57", "#ffaec9", "#ffc90e", "#efe4b0", "#b5e61d", "#99d9ea", "#7092be", "#c8bfe7"],
    columns: 10
  },
  office: {
    colors: ["#ffffff", "#000000", "#e6e6e6", "#435569", "#4371c4", "#ed7e32", "#a5a4a5", "#febf04", "#5a9bd5", "#71ae48", "#f2f2f3", "#7f7f7f", "#d1cece", "#d5dde3", "#dae1f4", "#fce5d4", "#deeded", "#fff2cc", "#deeaf6", "#e1efd9", "#d7d8d8", "#585959", "#aeabab", "#adbaca", "#b4c5e7", "#f6caac", "#dbdbdb", "#ffe498", "#bcd6ee", "#c5e0b2", "#bfbfc0", "#3f3f3f", "#767070", "#8595b1", "#8fabdb", "#f5b183", "#c9c8c9", "#fed965", "#9bc4e5", "#a8d08d", "#a5a5a6", "#262625", "#393939", "#334050", "#2e5496", "#c45a11", "#7b7b7a", "#bf9000", "#2f75b5", "#548235", "#7f7f7f", "#0b0c0c", "#161616", "#222a34", "#203764", "#843d0b", "#525252", "#7f6000", "#1d4d79", "#375623"],
    columns: 10
  },
  apex: {
    colors: ["#ffffff", "#000000", "#c9c2d1", "#69676d", "#ceb966", "#9cb084", "#6bb1c9", "#6585cf", "#7e6bc9", "#a379bb", "#f2f2f2", "#7f7f7f", "#f4f2f5", "#e0e0e2", "#f5f1e0", "#ebefe6", "#e1eff4", "#e0e6f5", "#e5e1f4", "#ece4f1", "#d8d8d8", "#595959", "#e9e6ec", "#c2c1c5", "#ebe3c1", "#d7dfcd", "#c3dfe9", "#c1ceeb", "#cbc3e9", "#dac9e3", "#bfbfbf", "#3f3f3f", "#dedae3", "#a4a3a8", "#e1d5a3", "#c3cfb5", "#a6d0de", "#a2b5e2", "#b1a6de", "#c7aed6", "#a5a5a5", "#262626", "#9688a5", "#4e4d51", "#ae9638", "#758c5a", "#3d8da9", "#365bb0", "#533da9", "#7d4d99", "#7f7f7f", "#0c0c0c", "#635672", "#343336", "#746425", "#4e5d3c", "#295e70", "#243c75", "#372970", "#533366"],
    columns: 10
  },
  austin: {
    colors: ["#ffffff", "#000000", "#caf278", "#3e3d2d", "#94c600", "#71685a", "#ff6700", "#909465", "#956b43", "#fea022", "#f2f2f2", "#7f7f7f", "#f4fce4", "#dddcd0", "#efffc0", "#e3e1dc", "#ffe0cb", "#e8e9df", "#ece1d6", "#feecd2", "#d8d8d8", "#595959", "#e9f9c9", "#bbb9a1", "#dfff82", "#c8c3ba", "#ffc299", "#d2d4c0", "#dac3ad", "#fed9a6", "#bfbfbf", "#3f3f3f", "#dff7ae", "#ada598", "#cfff43", "#ada598", "#ffa365", "#bcbfa1", "#c8a585", "#fec67a", "#a5a5a5", "#262626", "#a9ea25", "#2e2d21", "#6f9400", "#544e43", "#bf4d00", "#6c6f4b", "#6f5032", "#d77b00", "#7f7f7f", "#0c0c0c", "#74a50f", "#1f1e16", "#4a6300", "#38342d", "#7f3300", "#484a32", "#4a3521", "#8f5200"],
    columns: 10
  },
  clarity: {
    colors: ["#ffffff", "#292934", "#f3f2dc", "#d2533c", "#93a299", "#ad8f67", "#726056", "#4c5a6a", "#808da0", "#79463d", "#f2f2f2", "#e7e7ec", "#e7e5b9", "#f6dcd8", "#e9ecea", "#eee8e0", "#e4dedb", "#d8dde3", "#e5e8ec", "#e9d6d3", "#d8d8d8", "#c4c4d1", "#d5d185", "#edbab1", "#d3d9d6", "#ded2c2", "#c9beb8", "#b2bcc8", "#ccd1d9", "#d3aea7", "#bfbfbf", "#8a8aa3", "#aca73b", "#e4978a", "#bec7c1", "#cdbba3", "#af9e94", "#8c9bac", "#b2bac6", "#bd857c", "#a5a5a5", "#56566e", "#56531d", "#a43925", "#6b7c72", "#866b48", "#554840", "#39434f", "#5c697b", "#5a342d", "#7f7f7f", "#3b3b4b", "#22210b", "#6d2619", "#47534c", "#594730", "#39302b", "#262d35", "#3d4652", "#3c231e"],
    columns: 10
  },
  slipstream: {
    colors: ["#ffffff", "#000000", "#b4dcfa", "#212745", "#4e67c8", "#5eccf3", "#a7ea52", "#5dceaf", "#ff8021", "#f14124", "#f2f2f2", "#7f7f7f", "#8bc9f7", "#c7cce4", "#dbe0f4", "#def4fc", "#edfadc", "#def5ef", "#ffe5d2", "#fcd9d3", "#d8d8d8", "#595959", "#4facf3", "#909aca", "#b8c2e9", "#beeafa", "#dbf6b9", "#beebdf", "#ffcca6", "#f9b3a7", "#bfbfbf", "#3f3f3f", "#0d78c9", "#5967af", "#94a3de", "#9ee0f7", "#caf297", "#9de1cf", "#ffb279", "#f68d7b", "#a5a5a5", "#262626", "#063c64", "#181d33", "#31479f", "#11b2eb", "#81d319", "#34ac8b", "#d85c00", "#c3260c", "#7f7f7f", "#0c0c0c", "#021828", "#101322", "#202f6a", "#0b769c", "#568c11", "#22725c", "#903d00", "#821908"],
    columns: 10
  },
  metro: {
    colors: ["#ffffff", "#000000", "#d6ecff", "#4e5b6f", "#7fd13b", "#ea157a", "#feb80a", "#00addc", "#738ac8", "#1ab39f", "#f2f2f2", "#7f7f7f", "#a7d6ff", "#d9dde4", "#e5f5d7", "#fad0e4", "#fef0cd", "#c5f2ff", "#e2e7f4", "#c9f7f1", "#d8d8d8", "#595959", "#60b5ff", "#b3bcca", "#cbecb0", "#f6a1c9", "#fee29c", "#8be6ff", "#c7d0e9", "#94efe3", "#bfbfbf", "#3f3f3f", "#007dea", "#8d9baf", "#b2e389", "#f272af", "#fed46b", "#51d9ff", "#aab8de", "#5fe7d5", "#a5a5a5", "#262626", "#003e75", "#3a4453", "#5ea226", "#af0f5b", "#c58c00", "#0081a5", "#425ea9", "#138677", "#7f7f7f", "#0c0c0c", "#00192e", "#272d37", "#3f6c19", "#750a3d", "#835d00", "#00566e", "#2c3f71", "#0c594f"],
    columns: 10
  },
  flow: {
    colors: ["#ffffff", "#000000", "#dbf5f9", "#04617b", "#0f6fc6", "#009dd9", "#0bd0d9", "#10cf9b", "#7cca62", "#a5c249", "#f2f2f2", "#7f7f7f", "#b2e9f2", "#b4ecfc", "#c7e2fa", "#c4eeff", "#c9fafc", "#c9faed", "#e4f4df", "#edf2da", "#d8d8d8", "#595959", "#76d9e8", "#6adafa", "#90c6f6", "#89deff", "#93f5f9", "#94f6db", "#cae9c0", "#dbe6b6", "#bfbfbf", "#3f3f3f", "#21b2c8", "#20c8f7", "#59a9f2", "#4fceff", "#5df0f6", "#5ff2ca", "#b0dfa0", "#c9da91", "#a5a5a5", "#262626", "#105964", "#02485c", "#0b5394", "#0075a2", "#089ca2", "#0b9b74", "#54a838", "#7e9532", "#7f7f7f", "#0c0c0c", "#062328", "#01303d", "#073763", "#004e6c", "#05686c", "#07674d", "#387025", "#546321"],
    columns: 10
  },
  hardcover: {
    colors: ["#ffffff", "#000000", "#ece9c6", "#895d1d", "#873624", "#d6862d", "#d0be40", "#877f6c", "#972109", "#aeb795", "#f2f2f2", "#7f7f7f", "#e1dca5", "#f2e0c6", "#f0d0c9", "#f6e6d5", "#f5f2d8", "#e7e5e1", "#fbc7bc", "#eef0e9", "#d8d8d8", "#595959", "#d0c974", "#e6c28d", "#e2a293", "#eeceaa", "#ece5b2", "#cfccc3", "#f78f7a", "#dee2d4", "#bfbfbf", "#3f3f3f", "#a29a36", "#daa454", "#d4735e", "#e6b681", "#e2d88c", "#b7b2a5", "#f35838", "#ced3bf", "#a5a5a5", "#262626", "#514d1b", "#664515", "#65281a", "#a2641f", "#a39428", "#655f50", "#711806", "#879464", "#7f7f7f", "#0c0c0c", "#201e0a", "#442e0e", "#431b11", "#6c4315", "#6d621a", "#433f35", "#4b1004", "#5a6243"],
    columns: 10
  },
  trek: {
    colors: ["#ffffff", "#000000", "#fbeec9", "#4e3b30", "#f0a22e", "#a5644e", "#b58b80", "#c3986d", "#a19574", "#c17529", "#f2f2f2", "#7f7f7f", "#f7e09e", "#e1d6cf", "#fcecd5", "#eddfda", "#f0e7e5", "#f3eae1", "#ece9e3", "#f5e3d1", "#d8d8d8", "#595959", "#f3cc5f", "#c4ad9f", "#f9d9ab", "#dcc0b6", "#e1d0cc", "#e7d5c4", "#d9d4c7", "#ebc7a3", "#bfbfbf", "#3f3f3f", "#d29f0f", "#a78470", "#f6c781", "#cba092", "#d2b9b2", "#dbc1a7", "#c6bfab", "#e1ac76", "#a5a5a5", "#262626", "#694f07", "#3a2c24", "#c87d0e", "#7b4b3a", "#926255", "#a17242", "#7b7153", "#90571e", "#7f7f7f", "#0c0c0c", "#2a1f03", "#271d18", "#855309", "#523226", "#614138", "#6b4c2c", "#524b37", "#603a14"],
    columns: 10
  },
  verve: {
    colors: ["#ffffff", "#000000", "#d2d2d2", "#666666", "#ff388c", "#e40059", "#9c007f", "#68007f", "#005bd3", "#00349e", "#f2f2f2", "#7f7f7f", "#bdbdbd", "#e0e0e0", "#ffd7e8", "#ffc6dc", "#ffb8f1", "#f1b2ff", "#c3dcff", "#b8cfff", "#d8d8d8", "#595959", "#9d9d9d", "#c1c1c1", "#ffafd1", "#ff8eba", "#ff71e4", "#e365ff", "#87baff", "#72a0ff", "#bfbfbf", "#3f3f3f", "#696969", "#a3a3a3", "#ff87ba", "#ff5597", "#ff2ad7", "#d519ff", "#4b98ff", "#2b71ff", "#a5a5a5", "#262626", "#343434", "#4c4c4c", "#e90062", "#ab0042", "#75005f", "#4e005f", "#00449e", "#002676", "#7f7f7f", "#0c0c0c", "#151515", "#333333", "#9b0041", "#72002c", "#4e003f", "#34003f", "#002d69", "#00194f"],
    columns: 10
  },
  monochrome: {
    colors: ["#000000", "#1a1a1a", "#333333", "#4d4d4d", "#666666", "#808080", "#999999", "#b3b3b3", "#cccccc", "#e6e6e6", "#f2f2f2", "#ffffff"],
    columns: 12
  }
}, Cn = 24, Ga = 10, xn = "office";
class kt extends n.Component {
  constructor(t) {
    super(t), this.wrapper = null, this.paletteService = null, this.focus = () => {
      this.wrapper && this.wrapper.focus();
    }, this.onKeyDown = (e) => {
      switch (e.keyCode) {
        case z.down:
          this.handleCellNavigation(0, 1);
          break;
        case z.up:
          this.handleCellNavigation(0, -1);
          break;
        case z.right:
          this.handleCellNavigation(1, 0);
          break;
        case z.left:
          this.handleCellNavigation(-1, 0);
          break;
        case z.enter:
          this.handleEnter(e);
          break;
        default:
          return;
      }
      e.preventDefault();
    }, this.onColorClick = (e, s) => {
      this.isUncontrolled ? this.setState({ selectedColor: e, focusedColor: e }) : this.setState({ focusedColor: e }), this.dispatchChangeEvent(e, s);
    }, this.onFocus = (e) => {
      this.paletteService && (this.setState({ focusedColor: this.state.selectedColor || this.paletteService.colorRows[0][0] }), this.props.onFocus && this.props.onFocus.call(
        void 0,
        e
      ));
    }, this.onBlur = () => {
      this.setState({ focusedColor: void 0 });
    }, pe(me), this.state = {
      selectedColor: this.props.value !== void 0 ? this.props.value : this.props.defaultValue,
      isFirstRender: !0
    };
  }
  get guid() {
    return this.props.id;
  }
  /**
   * @hidden
   */
  render() {
    const t = this.getPaletteInfo(), e = this.paletteService = new Cs();
    e.setColorMatrix(t.colors, t.columns);
    const s = e.getCellCoordsFor(this.state.selectedColor), l = e.getCellCoordsFor(this.state.focusedColor), i = G("k-colorpalette", { "k-disabled": this.props.disabled }, this.props.className);
    return t.colors.length ? /* @__PURE__ */ n.createElement(
      "div",
      {
        id: this.props.id,
        role: "grid",
        className: i,
        onFocus: this.onFocus,
        onBlur: this.onBlur,
        onKeyDown: this.onKeyDown,
        "aria-disabled": this.props.ariaDisabled || (this.props.disabled ? "true" : void 0),
        "aria-labelledby": this.props.ariaLabelledBy,
        "aria-describedby": this.props.ariaDescribedBy,
        tabIndex: ie(this.props.tabIndex, this.props.disabled),
        ref: (c) => this.wrapper = c
      },
      /* @__PURE__ */ n.createElement("table", { className: "k-colorpalette-table", role: "presentation" }, /* @__PURE__ */ n.createElement("tbody", { role: "rowgroup" }, this.renderRows(e.colorRows, s, l)))
    ) : "";
  }
  /**
   * @hidden
   */
  static getDerivedStateFromProps(t, e) {
    if (!e.isFirstRender && t.value !== void 0) {
      if (t.value === "" && e.selectedColor !== void 0)
        return { selectedColor: void 0 };
      if (t.value !== "" && t.value !== e.selectedColor)
        return { selectedColor: t.value };
    } else if (e.isFirstRender)
      return { isFirstRender: !1 };
    return null;
  }
  handleCellNavigation(t, e) {
    if (this.paletteService)
      if (this.focusedColorCooridanates) {
        const s = this.paletteService.getNextCell(
          this.focusedColorCooridanates,
          t,
          e
        );
        this.setState({ focusedColor: this.paletteService.getColorAt(s) });
      } else
        this.setState({ focusedColor: this.paletteService.colorRows[0][0] });
  }
  handleEnter(t) {
    this.isUncontrolled && this.setState({ selectedColor: this.state.focusedColor }), this.dispatchChangeEvent(this.state.focusedColor, t);
  }
  dispatchChangeEvent(t, e) {
    Q(this.props.onChange, e, this, { value: t, rgbaValue: Ne(t, "rgba") });
  }
  get focusedColorCooridanates() {
    return this.state.focusedColor && this.paletteService ? this.paletteService.getCellCoordsFor(this.state.focusedColor) : void 0;
  }
  get isUncontrolled() {
    return this.props.value === void 0;
  }
  getPaletteInfo() {
    if (typeof this.props.palette == "string") {
      const t = xs[this.props.palette];
      return ae(t) ? {
        colors: t.colors,
        columns: this.props.columns || t.columns || Ga
      } : { colors: [], columns: 0 };
    } else
      return { colors: this.props.palette || [], columns: this.props.columns || Ga };
  }
  renderRows(t, e, s) {
    return t.map((l, i) => /* @__PURE__ */ n.createElement("tr", { role: "row", key: i }, this.renderColumns(l, i, e, s)));
  }
  renderColumns(t, e, s, l) {
    const i = s !== void 0 && s.row === e, c = s && s.col, o = l !== void 0 && l.row === e, f = l && l.col, d = typeof this.props.tileSize != "number" ? this.props.tileSize : { width: this.props.tileSize, height: this.props.tileSize }, m = d.width + "px", u = d.height + "px";
    return t.map((h, y) => {
      const M = i && c === y, D = G(
        "k-colorpalette-tile",
        {
          "k-selected": M,
          "k-focus": o && f === y
        }
      );
      return /* @__PURE__ */ n.createElement(
        "td",
        {
          role: "gridcell",
          className: D,
          "aria-label": h,
          "aria-selected": M ? !0 : this.props.disabled ? void 0 : !1,
          style: { backgroundColor: h, width: m, height: u, minWidth: m },
          onClick: (N) => this.onColorClick(h, N),
          id: this.createCellId({ row: e, col: y }),
          key: y
        }
      );
    });
  }
  createCellId(t) {
    return `${this.guid}_${t.row}_${t.col}`;
  }
}
kt.displayName = "ColorPalette";
kt.propTypes = {
  palette: r.oneOfType([r.arrayOf(r.string.isRequired), r.string]),
  columns: r.number,
  tileSize: r.any,
  defaultValue: r.string,
  value: r.string,
  disabled: r.bool,
  tabIndex: r.number,
  onChange: r.func,
  onFocus: r.func,
  id: r.string,
  ariaLabelledBy: r.string,
  ariaDescribedBy: r.string,
  className: r.string
};
kt.defaultProps = {
  palette: xn,
  tileSize: Cn
};
const Es = he(), ma = et(Ue(Es, kt));
ma.displayName = "KendoReactColorPalette";
const Ss = "bottom", ws = "top", En = (a) => {
  const t = a.popupSettings || {}, e = a.dir === "rtl" ? "right" : "left", s = n.useMemo(
    () => ({ horizontal: e, vertical: Ss }),
    [e]
  ), l = n.useMemo(
    () => ({ horizontal: e, vertical: ws }),
    [e]
  );
  return /* @__PURE__ */ n.createElement(n.Fragment, null, a.input, a.button, /* @__PURE__ */ n.createElement(
    An,
    {
      style: {
        ...(t || {}).style,
        direction: a.dir
      },
      ...t,
      anchor: a.popupAnchor,
      anchorAlign: s,
      popupAlign: l,
      show: a.open,
      onOpen: a.onOpen,
      onClose: a.onClose,
      className: G("k-reset", t.className)
    },
    a.content
  ));
};
En.displayName = "KendoPickerComponent";
const Is = {
  opacity: !0
}, Ls = {
  palette: xn,
  tileSize: Cn
}, Bt = (a) => a !== void 0, Rs = he(), ga = n.forwardRef((a, t) => {
  pe(me);
  const e = Re(Rs, a), s = _e(), {
    size: l = dt.size,
    rounded: i = dt.rounded,
    fillMode: c = dt.fillMode,
    popupSettings: o,
    gradientSettings: f,
    paletteSettings: d,
    valid: m,
    disabled: u,
    tabIndex: h,
    view: y,
    icon: M,
    svgIcon: D,
    iconClassName: N,
    onChange: L,
    onFocus: S,
    onBlur: w,
    onActiveColorClick: B,
    className: O
  } = e, I = n.useRef(null), F = n.useRef(null), _ = n.useRef(null), T = n.useRef(), E = n.useRef(null), [V, H] = n.useState(!1), [q, Z] = n.useState(e.defaultValue), [p, v] = n.useState(!1), g = Bt(e.value), k = Bt(e.open), C = g ? e.value : q, P = k ? e.open : p, j = n.useCallback(
    () => {
      I.current && I.current.focus();
    },
    []
  );
  n.useImperativeHandle(t, () => ({
    // we agreed that each element will have focus method exposed
    element: I.current,
    actionElement: E.current,
    value: C,
    focus: j
  }), [C, j]);
  const J = n.useCallback(
    (A, xe) => {
      k || (!A && !xe && I && I.current && I.current.focus(), v(A));
    },
    [k]
  ), R = n.useCallback(
    (A) => {
      const { altKey: xe, keyCode: ve } = A;
      if (ve === z.esc) {
        J(!1);
        return;
      }
      if (ve === z.enter && !k) {
        A.preventDefault(), A.stopPropagation(), J(!P);
        return;
      }
      xe && (ve === z.up || ve === z.down) && (A.preventDefault(), A.stopPropagation(), ve === z.up && I && I.current && (I.current.focus(), J(!1)), ve === z.down && J(!0));
    },
    [P, k]
  ), b = n.useCallback(
    () => {
      k || (F.current ? F.current.focus() : _.current && _.current.focus());
    },
    [k]
  ), W = n.useCallback(
    () => {
      J(!P, !0);
    },
    [P]
  ), K = n.useCallback(
    (A) => {
      B && B.call(void 0, {
        syntheticEvent: A,
        nativeEvent: A.nativeEvent,
        value: C
      });
    },
    [B, C]
  ), ee = n.useCallback(
    (A) => {
      T.current ? (clearTimeout(T.current), T.current = void 0) : H(!0), S && S.call(void 0, {
        nativeEvent: A.nativeEvent,
        syntheticEvent: A
      });
    },
    [S]
  ), le = n.useCallback(
    () => {
      J(!1, !0), H(!1), T.current = void 0;
    },
    []
  ), Ee = n.useCallback(
    (A) => {
      clearTimeout(T.current), T.current = window.setTimeout(le), w && w.call(void 0, {
        nativeEvent: A.nativeEvent,
        syntheticEvent: A
      });
    },
    [w]
  ), oe = n.useCallback(
    (A, xe) => {
      const ve = xe ? A.rgbaValue : A.value;
      g || Z(ve), xe && J(!1), L && L.call(void 0, {
        value: ve,
        nativeEvent: A.nativeEvent,
        syntheticEvent: A.syntheticEvent
      });
    },
    [g, L]
  ), ce = n.useCallback(
    (A) => oe(A, !0),
    [Bt, oe]
  ), be = Ae(I, e.dir), He = m !== !1;
  return /* @__PURE__ */ n.createElement(
    "span",
    {
      id: e.id,
      role: "combobox",
      "aria-label": e.ariaLabel,
      "aria-labelledby": e.ariaLabelledBy,
      "aria-describedby": e.ariaDescribedBy,
      "aria-haspopup": "dialog",
      "aria-expanded": P,
      "aria-disabled": u ? "true" : void 0,
      className: G(
        "k-colorpicker",
        "k-picker",
        "k-icon-picker",
        {
          [`k-picker-${ne.sizeMap[l] || l}`]: l,
          [`k-picker-${c}`]: c,
          [`k-rounded-${ne.roundedMap[i] || i}`]: i,
          "k-invalid": !He,
          "k-disabled": u,
          "k-focus": V,
          className: O
        }
      ),
      ref: I,
      tabIndex: ie(h, u),
      title: e.title,
      onKeyDown: R,
      onFocus: ee,
      onBlur: Ee,
      dir: be
    },
    /* @__PURE__ */ n.createElement(
      En,
      {
        dir: be,
        open: P,
        onOpen: b,
        popupAnchor: I.current || void 0,
        popupSettings: { ...o },
        input: /* @__PURE__ */ n.createElement("span", { onClick: K, className: "k-input-inner" }, /* @__PURE__ */ n.createElement(
          "span",
          {
            className: G(
              "k-value-icon",
              "k-color-preview",
              {
                "k-no-color": !C,
                "k-icon-color-preview": M || D || N
              }
            )
          },
          N && /* @__PURE__ */ n.createElement("span", { className: G("k-color-preview-icon", N) }),
          !N && (M || D) && /* @__PURE__ */ n.createElement(fe, { name: M, icon: D }),
          /* @__PURE__ */ n.createElement("span", { className: "k-color-preview-mask", style: { backgroundColor: C } })
        )),
        button: /* @__PURE__ */ n.createElement(
          ge,
          {
            tabIndex: -1,
            type: "button",
            onClick: W,
            className: "k-input-button",
            rounded: null,
            icon: "caret-alt-down",
            svgIcon: ht,
            "aria-label": s.toLanguageString(Qt, $[Qt])
          }
        ),
        content: /* @__PURE__ */ n.createElement(n.Fragment, null, (y === "combo" || y === "gradient") && /* @__PURE__ */ n.createElement(
          pa,
          {
            ...f,
            tabIndex: 0,
            ref: F,
            value: C,
            onChange: oe
          }
        ), (y === "combo" || y === "palette") && /* @__PURE__ */ n.createElement(
          ma,
          {
            ...d,
            ref: _,
            value: C,
            onChange: ce
          }
        ))
      }
    )
  );
});
ga.propTypes = {
  value: r.string,
  defaultValue: r.string,
  disabled: r.bool,
  view: r.oneOf(["gradient", "palette", "combo"]),
  dir: r.string,
  id: r.string,
  icon: r.string,
  svgIcon: Ft,
  ariaLabelledBy: r.string,
  ariaDescribedBy: r.string,
  size: r.oneOf([null, "small", "medium", "large"]),
  rounded: r.oneOf([null, "small", "medium", "large", "full"]),
  fillMode: r.oneOf([null, "solid", "flat", "outline"]),
  className: r.string
};
const dt = {
  size: "medium",
  rounded: "medium",
  fillMode: "solid",
  view: "palette",
  gradientSettings: Is,
  paletteSettings: Ls
};
ga.defaultProps = dt;
ga.displayName = "KendoColorPicker";
const Ka = "rgba(255, 255, 255, 1)", Sn = n.forwardRef((a, t) => {
  pe(me);
  const e = n.useRef(null), s = n.useRef(null), l = n.useRef(null), { defaultValue: i = Ka, showButtons: c = !0, showPreview: o = !0, showClearButton: f = !0 } = a, [d, m] = n.useState((a.view || "ColorGradient") === "ColorGradient"), [u, h] = n.useState(a.value || i), [y, M] = n.useState(a.value || i), D = a.value !== void 0 ? a.value : y;
  n.useEffect(() => {
    h(a.value || i);
  }, [a.value, i]);
  const N = _e(), L = n.useCallback(
    () => {
      e.current && e.current.focus();
    },
    [e]
  );
  n.useImperativeHandle(e, () => ({
    element: s.current,
    focus: L,
    props: a,
    value: D
  }), [D, L, a]), n.useImperativeHandle(t, () => e.current);
  const S = n.useCallback(
    (E) => {
      (E === "ColorGradient" && !d || E === "ColorPalette" && d) && m(!d);
    },
    [d]
  ), w = n.useCallback(
    (E) => {
      if (h(i), a.onPreviewChange) {
        const V = {
          value: i,
          nativeEvent: E.nativeEvent,
          syntheticEvent: E
        };
        a.onPreviewChange.call(void 0, V);
      }
    },
    [i, a.onPreviewChange]
  ), B = n.useCallback(
    (E) => {
      if (h(E.value), a.onPreviewChange) {
        const V = {
          value: E.value,
          nativeEvent: E.nativeEvent,
          syntheticEvent: E.syntheticEvent
        };
        a.onPreviewChange.call(void 0, V);
      }
    },
    [a.onPreviewChange]
  ), O = n.useCallback(
    (E) => {
      if (M(u), a.onChange) {
        const V = {
          value: u,
          nativeEvent: E.nativeEvent,
          syntheticEvent: E
        };
        a.onChange.call(void 0, V);
      }
    },
    [u, a.onChange]
  ), I = n.useCallback(
    () => {
      M(Ka);
    },
    []
  ), F = n.useCallback(
    (E) => {
      if (h(y), a.onPreviewChange) {
        const V = {
          value: y,
          nativeEvent: E.nativeEvent,
          syntheticEvent: E
        };
        a.onPreviewChange.call(void 0, V);
      }
    },
    [y, a.onPreviewChange]
  ), _ = n.useCallback(
    (E) => {
      s.current && !(E.nativeEvent.target instanceof HTMLInputElement) && s.current.focus();
    },
    [s]
  ), T = n.useCallback(
    (E) => {
      var H;
      if ((!E.relatedTarget || !((H = s.current) != null && H.contains(E.relatedTarget))) && (c || M(u), !c && a.onChange)) {
        const q = {
          value: u,
          nativeEvent: E.nativeEvent,
          syntheticEvent: E
        };
        a.onChange.call(void 0, q);
      }
    },
    [u, c, a.onChange]
  );
  return /* @__PURE__ */ n.createElement(
    "div",
    {
      id: a.id,
      role: "textbox",
      "aria-label": a.ariaLabel,
      "aria-labelledby": a.ariaLabelledBy,
      "aria-disabled": a.disabled ? "true" : void 0,
      style: a.style,
      ref: s,
      tabIndex: ie(a.tabIndex, a.disabled),
      className: G(
        "k-flatcolorpicker k-coloreditor",
        {
          "k-disabled": a.disabled
        },
        a.className
      ),
      onBlur: T
    },
    /* @__PURE__ */ n.createElement(n.Fragment, null, a.header || /* @__PURE__ */ n.createElement("div", { className: "k-coloreditor-header k-hstack" }, /* @__PURE__ */ n.createElement("div", { className: "k-coloreditor-header-actions k-hstack" }, /* @__PURE__ */ n.createElement(_n, { className: "k-button-group-flat" }, /* @__PURE__ */ n.createElement(
      ge,
      {
        type: "button",
        "aria-label": N.toLanguageString(
          Xt,
          $[Xt]
        ),
        togglable: !0,
        fillMode: "flat",
        selected: d,
        onClick: () => S("ColorGradient"),
        icon: "droplet-slider",
        svgIcon: Fn
      }
    ), /* @__PURE__ */ n.createElement(
      ge,
      {
        type: "button",
        "aria-label": N.toLanguageString(
          Yt,
          $[Yt]
        ),
        togglable: !0,
        fillMode: "flat",
        selected: !d,
        onClick: () => S("ColorPalette"),
        icon: "palette",
        svgIcon: Tn
      }
    ))), /* @__PURE__ */ n.createElement("div", { className: "k-spacer" }), /* @__PURE__ */ n.createElement("div", { className: "k-coloreditor-header-actions k-hstack" }, f && /* @__PURE__ */ n.createElement(
      ge,
      {
        type: "button",
        fillMode: "flat",
        onClick: w,
        "aria-label": N.toLanguageString(
          Zt,
          $[Zt]
        ),
        icon: "droplet-slash",
        svgIcon: zn
      }
    ), o && /* @__PURE__ */ n.createElement("div", { className: "k-coloreditor-preview k-vstack" }, /* @__PURE__ */ n.createElement("span", { className: "k-coloreditor-preview-color k-color-preview", style: { background: u } }), /* @__PURE__ */ n.createElement("span", { className: "k-coloreditor-current-color k-color-preview", style: { background: y }, onClick: F })))), /* @__PURE__ */ n.createElement("div", { className: "k-coloreditor-views k-vstack" }, d ? /* @__PURE__ */ n.createElement(
      pa,
      {
        ref: l,
        role: "none",
        tabIndex: -1,
        ariaLabel: void 0,
        value: u,
        onChange: B,
        onFocus: _,
        opacity: a.opacity,
        format: a.format
      }
    ) : /* @__PURE__ */ n.createElement(ma, { ariaDisabled: !0, ariaLabelledBy: "required_label", value: u, onChange: B, onFocus: _ })), c && /* @__PURE__ */ n.createElement("div", { className: "k-coloreditor-footer k-actions k-actions-end" }, /* @__PURE__ */ n.createElement(ge, { type: "button", className: "k-coloreditor-cancel", onClick: I }, $[on]), /* @__PURE__ */ n.createElement(ge, { type: "button", className: "k-coloreditor-apply k-primary", onClick: O }, $[cn])))
  );
}), Vs = {
  id: r.string,
  style: r.any,
  className: r.string,
  value: r.string,
  defaultValue: r.string,
  onPreviewChange: r.func,
  onChange: r.func,
  opacity: r.bool,
  format: r.any,
  tabIndex: r.number,
  ariaLabel: r.string,
  ariaLabelledBy: r.string,
  disabled: r.bool,
  view: r.any,
  header: r.any,
  showClearButton: r.bool,
  showPreview: r.bool,
  showButtons: r.bool
};
Sn.displayName = "KendoFlatColorPicker";
Sn.propTypes = Vs;
var Pe = /* @__PURE__ */ ((a) => (a[a.Literal = 0] = "Literal", a[a.Mask = 1] = "Mask", a[a.Undefined = 2] = "Undefined", a))(Pe || {});
class Y {
  constructor(t, e, s = 2) {
    this.value = t, this.rest = e, this.type = s;
  }
  // map :: Functor f => f a ~> (a -> b) -> f b
  map(t) {
    return new Y(t(this.value), this.rest);
  }
  // chain :: Chain m => m a ~> (a -> m b) -> m b
  chain(t) {
    return t(this.value, this.rest);
  }
  fold(t, e) {
    return t(this.value, this.rest);
  }
  concat(t) {
    return this.map((e, s) => t.chain((l, i) => e.concat([l])));
  }
  toString() {
    return `Result({ value: '${this.value}', rest: ${this.rest} })`;
  }
}
class qa {
  constructor(t = [], e = []) {
    this.input = t, this.control = e, this.inputCursor = 0, this.controlCursor = 0;
  }
  eof() {
    return this.inputCursor >= this.input.length;
  }
  // Get the first value from the input.
  next() {
    return {
      char: this.input[this.inputCursor++],
      control: this.control[this.controlCursor++]
    };
  }
  peek() {
    return {
      char: this.input[this.inputCursor],
      control: this.control[this.controlCursor]
    };
  }
  eat_input() {
    this.inputCursor++;
  }
  eat_control() {
    this.controlCursor++;
  }
  eat() {
    this.inputCursor++, this.controlCursor++;
  }
}
const Ua = (a) => (a || "").split(""), Ms = "\\";
class Ce {
  constructor(t) {
    this.parse = t;
  }
  run(t, e = "") {
    return t instanceof qa ? this.parse(t) : this.parse(new qa(Ua(t), Ua(e)));
  }
  // map :: Functor f => f a ~> (a -> b) -> f b
  map(t) {
    return new Ce((e) => this.parse(e).map(t));
  }
  // chain :: Chain m => m a ~> (a -> m b) -> m b
  chain(t) {
    return new Ce((e) => this.parse(e).chain((s, l) => t(s).run(l)));
  }
  isLiteral(t) {
    return this.run(t).type === Pe.Literal;
  }
}
const Ns = (a) => (t) => new Ce((e) => {
  const { prompt: s, promptPlaceholder: l } = a;
  for (; !e.eof(); ) {
    const { char: i, control: c } = e.peek();
    if (i === c && c === s)
      return e.eat(), new Y(s, e, Pe.Mask);
    if (t.test(i))
      return e.eat(), new Y(i, e, Pe.Mask);
    if (i === l)
      return e.eat(), new Y(s, e, Pe.Mask);
    e.eat_input();
  }
  return e.eat(), new Y(s, e, Pe.Mask);
}), Ps = (a) => new Ce((t) => t.peek().char === a ? (t.eat(), new Y(a, t, Pe.Literal)) : new Y(a, t, Pe.Literal)), Ds = (a) => (t) => new Ce((e) => {
  for (; !e.eof(); ) {
    const { char: s, control: l } = e.peek();
    if (s === a && l === a)
      return e.eat(), new Y(s, e);
    if (t.test(s))
      return e.eat(), new Y(s, e);
    e.eat_input();
  }
  return e.eat(), new Y("", e);
}), Bs = (a) => new Ce((t) => {
  if (t.eof())
    return new Y("", t);
  const { char: e } = t.peek();
  return e === a && t.eat(), new Y(a, t);
}), ot = (a, t) => new Ce((e) => {
  let { char: s } = e.next();
  const l = a[s];
  return s === Ms ? (s = e.next().char, new Y(t.literal(s), e)) : l ? new Y(t.mask(l), e) : new Y(t.literal(s), e);
}), ja = (a) => new Ce((t) => {
  const { prompt: e, promptPlaceholder: s } = a;
  let { char: l } = t.next();
  return l === e ? new Y(s, t) : new Y(l, t);
}), Wa = (a) => new Ce((t) => {
  let { char: e } = t.next();
  return a ? new Y(e, t) : new Y("", t);
}), Os = (a) => new Ce((t) => new Y(a, t)), Fs = (a, t) => a.chain((e) => t.map((s) => e.concat([s]))), Oe = (a) => a.reduce((t, e) => Fs(t, e), Os([])), ct = (a) => new Ce((t) => {
  let e = new Y([], t);
  for (; !t.eof(); )
    e = e.concat(a.run(t));
  return e;
});
class Ts {
  constructor() {
    this.rules = {}, this.prompt = "_", this.mask = "", this.promptPlaceholder = " ", this.includeLiterals = !1, this.maskTokens = [], this.unmaskTokens = [], this.rawTokens = [], this.validationTokens = [];
  }
  update({ mask: t = "", prompt: e = "", promptPlaceholder: s = " ", rules: l = {}, includeLiterals: i = !1 }) {
    this.mask = t, this.prompt = e, this.promptPlaceholder = s, this.rules = l, this.includeLiterals = i, this.tokenize();
  }
  validationValue(t = "") {
    let e = t;
    return Oe(this.validationTokens).run(t).fold((s) => {
      e = s.join("");
    }), e;
  }
  rawValue(t = "") {
    let e = t;
    return this.rawTokens.length && Oe(this.rawTokens).run(t).fold((s) => {
      e = s.join("");
    }), e;
  }
  /**
   * @hidden
   */
  maskRaw(t = "") {
    let e = t;
    return this.maskTokens.length && Oe(this.maskTokens).run(t).fold((s) => {
      e = s.join("");
    }), e;
  }
  maskInput(t, e, s) {
    return t.length < e.length ? this.maskRemoved(t, e, s) : this.maskInserted(t, e, s);
  }
  maskInRange(t, e, s, l) {
    let i = "", c = l;
    const o = e.split("").slice(0, s), f = e.split("").slice(l);
    return Oe(this.maskTokens.slice(s, l)).run(t).fold((d) => {
      i = o.concat(d).concat(f).join("");
    }), {
      selection: c,
      value: i
    };
  }
  maskRemoved(t, e, s) {
    let l = "", i = s;
    const c = t.split("").slice(s), o = t.split("").slice(0, s).join(""), f = this.maskTokens.length - (t.length - s);
    return Oe(this.maskTokens.slice(0, f)).run(o, e).fold((d) => {
      i = this.adjustPosition(d, i), l = d.concat(c).join("");
    }), {
      selection: i,
      value: l
    };
  }
  adjustPosition(t, e) {
    const s = t[e];
    return !this.maskTokens[e].isLiteral(s) && s !== this.prompt ? e + 1 : e;
  }
  maskInserted(t, e, s) {
    let l = "", i = s;
    const c = t.slice(0, s);
    return Oe(this.unmaskTokens).run(c, e).chain((o) => {
      i = o.join("").length;
      const f = e.slice(i);
      return Oe(this.maskTokens).run(o.join("") + f, e);
    }).fold((o) => {
      l = o.join("");
    }), {
      selection: i,
      value: l
    };
  }
  get maskTokenCreator() {
    const { prompt: t, promptPlaceholder: e } = this;
    return {
      literal: (s) => Ps(s),
      mask: (s) => Ns({ prompt: t, promptPlaceholder: e })(s)
    };
  }
  get unmaskTokenCreator() {
    return {
      literal: (t) => Bs(t),
      mask: (t) => Ds(this.prompt)(t)
    };
  }
  get rawTokenCreator() {
    const { prompt: t, promptPlaceholder: e, includeLiterals: s } = this;
    return {
      literal: (l) => Wa(s),
      mask: (l) => ja({ prompt: t, promptPlaceholder: e })
    };
  }
  get validationTokenCreator() {
    const { prompt: t } = this;
    return {
      literal: (e) => Wa(!1),
      mask: (e) => ja({ prompt: t, promptPlaceholder: "" })
    };
  }
  tokenize() {
    ct(ot(this.rules, this.maskTokenCreator)).run(this.mask).fold((t, e) => {
      this.maskTokens = t;
    }), ct(ot(this.rules, this.unmaskTokenCreator)).run(this.mask).fold((t, e) => {
      this.unmaskTokens = t;
    }), ct(ot(this.rules, this.rawTokenCreator)).run(this.mask).fold((t, e) => {
      this.rawTokens = t;
    }), ct(ot(this.rules, this.validationTokenCreator)).run(this.mask).fold((t, e) => {
      this.validationTokens = t;
    });
  }
}
const wn = {
  "#": /[\d\s\+\-]/,
  "&": /[\S]/,
  0: /[\d]/,
  9: /[\d\s]/,
  "?": /[a-zA-Z\s]/,
  A: /[a-zA-Z0-9]/,
  C: /./,
  L: /[a-zA-Z]/,
  a: /[a-zA-Z0-9\s]/
}, Xa = () => !1, zs = (a, t) => a.includeLiterals !== t.includeLiterals || a.mask !== t.mask || a.prompt !== t.prompt || a.promptPlaceholder !== t.promptPlaceholder || !_s(a.rules, t.rules), _s = (a, t) => {
  if (!!a != !!t)
    return !1;
  if (a === t || !a || !t)
    return !0;
  let e = !0;
  for (const s in a)
    if (a[s] !== t[s]) {
      e = !1;
      break;
    }
  if (e) {
    for (const s in t)
      if (!a.hasOwnProperty(s)) {
        e = !1;
        break;
      }
  }
  return e;
}, Ve = class extends n.Component {
  constructor(a) {
    super(a), this.state = {}, this._inputId = `k-${this.props.id}`, this._service = new Ts(), this._isPasted = !1, this._selection = [null, null], this._input = null, this.focus = () => {
      this._input && this._input.focus();
    }, this.pasteHandler = (t) => {
      const { selectionStart: e, selectionEnd: s } = t.target;
      s !== e && (this._isPasted = !0, this._selection = [e || 0, s || 0]);
    }, this.onChangeHandler = (t) => {
      const e = t.currentTarget, s = e.value, l = this._selection[0] || 0, i = this._selection[1] || 0;
      if (!this.props.mask) {
        this._isPasted = !1, this._selection = [null, null], this.triggerOnChange(s, t);
        return;
      }
      const c = this.value;
      let o;
      if (this._isPasted) {
        this._isPasted = !1;
        const f = c.length - i, d = s.length - f;
        o = this._service.maskInRange(s.slice(l, d), c, l, i);
      } else
        o = this._service.maskInput(s, c, e.selectionStart || 0);
      this._selection = [o.selection, o.selection], this.triggerOnChange(o.value, t);
    }, this.focusHandler = (t) => {
      this.state.focused || (this.setState({ focused: !0 }), this.props.onFocus && this.props.onFocus.call(void 0, {
        target: this,
        syntheticEvent: t,
        nativeEvent: t.nativeEvent
      }));
    }, this.blurHandler = (t) => {
      this.state.focused && (this.setState({ focused: !1 }), this.props.onBlur && this.props.onBlur.call(void 0, {
        target: this,
        syntheticEvent: t,
        nativeEvent: t.nativeEvent
      }));
    }, this.setValidity = () => {
      this.element && this.element.setCustomValidity(
        this.validity.valid ? "" : this.props.validationMessage || ""
      );
    }, pe(me);
  }
  /**
   * Gets the element of the MaskedTextBox.
   *
   * @return - An `HTMLInputElement`.
   *
   * @example
   * ```jsx
   * class App extends React.Component {
   *     constructor(props) {
   *         super(props);
   *     }
   *     element = null;
   *     render() {
   *         return (
   *             <div>
   *                 <MaskedTextBox
   *                     ref={(component) =>
   *                         this.element = component ? component.element : null}
   *                 />
   *                 <button onClick={() => console.log(this.element)}>console.log the element</button>
   *             </div>
   *         );
   *     }
   * }
   *
   * ReactDOM.render(
   *     <App />,
   *     document.getElementsByTagName('my-app')[0]
   * );
   * ```
   */
  get element() {
    return this._input;
  }
  /**
   * Gets the value with the mask of the MaskedTextBox.
   */
  get value() {
    return this._valueDuringOnChange !== void 0 ? this._valueDuringOnChange : this.props.value !== void 0 ? this.props.value : this.state.value !== void 0 ? this.state.value : this.props.defaultValue !== void 0 ? this.props.defaultValue : "";
  }
  /**
   * Gets the raw value without the mask of the MaskedTextBox.
   */
  get rawValue() {
    return this._service.rawValue(this.value);
  }
  /**
   * Represents the validity state into which the MaskedTextBox is set.
   */
  get validity() {
    const a = this.value, t = this._service.validationValue(a), e = this.props.validationMessage !== void 0, s = this.props.valid !== void 0 ? this.props.valid : (!this.required || !!t) && (!this.props.maskValidation || !this.props.prompt || a.indexOf(this.props.prompt) === -1);
    return {
      customError: e,
      valid: s,
      valueMissing: !t
    };
  }
  /**
   * @hidden
   */
  get validityStyles() {
    return this.props.validityStyles !== void 0 ? this.props.validityStyles : Ve.defaultProps.validityStyles;
  }
  /**
   * @hidden
   */
  get required() {
    return this.props.required !== void 0 ? this.props.required : Ve.defaultProps.required;
  }
  /**
   * Gets the `name` property of the MaskedTextBox.
   */
  get name() {
    return this.props.name;
  }
  /**
   * @hidden
   */
  componentDidUpdate(a, t) {
    if (this.element && this.state.focused && t.focused) {
      let [e, s] = this._selection;
      const l = a.selection, i = this.props.selection;
      (!l && i || l && i && (l.start !== i.start || l.end !== i.end)) && (e = i.start, s = i.end), e !== null && s !== null && this.element.setSelectionRange(e, s);
    }
    zs(a, this.props) && this.updateService(), this.setValidity();
  }
  /**
   * @hidden
   */
  componentDidMount() {
    this.updateService(), this.setValidity();
  }
  /**
   * @hidden
   */
  render() {
    const {
      size: a = Ve.defaultProps.size,
      fillMode: t = Ve.defaultProps.fillMode,
      rounded: e = Ve.defaultProps.rounded
    } = this.props, s = this.props.id || this._inputId, l = !this.validityStyles || this.validity.valid, i = this.props.style || {}, {
      prefix: c = Ve.defaultProps.prefix,
      suffix: o = Ve.defaultProps.suffix
    } = this.props, [f] = qe(c), [d] = qe(o), m = /* @__PURE__ */ n.createElement(
      "span",
      {
        dir: this.props.dir,
        className: G(
          "k-maskedtextbox k-input",
          {
            [`k-input-${ne.sizeMap[a] || a}`]: a,
            [`k-input-${t}`]: t,
            [`k-rounded-${ne.roundedMap[e] || e}`]: e,
            "k-invalid": !l,
            "k-required": this.required,
            "k-disabled": this.props.disabled
          },
          this.props.className
        ),
        style: this.props.label ? i : { width: this.props.width, ...i }
      },
      /* @__PURE__ */ n.createElement(f, null),
      /* @__PURE__ */ n.createElement(
        "input",
        {
          type: "text",
          autoComplete: "off",
          autoCorrect: "off",
          autoCapitalize: "off",
          spellCheck: !1,
          className: "k-input-inner",
          value: this.value,
          id: s,
          "aria-labelledby": this.props.ariaLabelledBy,
          "aria-describedby": this.props.ariaDescribedBy,
          "aria-placeholder": this.props.mask,
          name: this.props.name,
          tabIndex: ie(this.props.tabIndex, this.props.disabled, !0),
          accessKey: this.props.accessKey,
          title: this.props.title,
          disabled: this.props.disabled || void 0,
          readOnly: this.props.readonly || void 0,
          placeholder: this.props.placeholder,
          ref: (u) => this._input = u,
          onChange: this.onChangeHandler,
          onPaste: this.pasteHandler,
          onFocus: this.focusHandler,
          onBlur: this.blurHandler,
          onDragStart: Xa,
          onDrop: Xa
        }
      ),
      /* @__PURE__ */ n.createElement(d, null)
    );
    return this.props.label ? /* @__PURE__ */ n.createElement(
      ua,
      {
        label: this.props.label,
        editorId: s,
        editorValue: this.value,
        editorValid: l,
        editorDisabled: this.props.disabled,
        editorPlaceholder: this.props.placeholder,
        children: m,
        style: { width: this.props.width },
        dir: this.props.dir
      }
    ) : m;
  }
  triggerOnChange(a, t) {
    if (this.setState({
      value: a
    }), this.props.onChange) {
      this._valueDuringOnChange = a;
      const e = {
        syntheticEvent: t,
        nativeEvent: t.nativeEvent,
        selectionStart: this._selection[0],
        selectionEnd: this._selection[1],
        target: this,
        value: this.value
      };
      this.props.onChange.call(void 0, e), this._valueDuringOnChange = void 0;
    }
  }
  updateService(a) {
    const t = Object.assign({
      includeLiterals: this.props.includeLiterals,
      mask: this.props.mask,
      prompt: this.props.prompt,
      promptPlaceholder: this.props.promptPlaceholder,
      rules: this.rules
    }, a);
    this._service.update(t);
  }
  get rules() {
    return Object.assign({}, wn, this.props.rules);
  }
};
let yt = Ve;
yt.displayName = "MaskedTextBox";
yt.propTypes = {
  value: r.string,
  defaultValue: r.string,
  placeholder: r.string,
  title: r.string,
  dir: r.string,
  id: r.string,
  style: r.object,
  className: r.string,
  prefix: r.any,
  suffix: r.any,
  ariaLabelledBy: r.string,
  ariaDescribedBy: r.string,
  width: r.oneOfType([
    r.string,
    r.number
  ]),
  tabIndex: r.number,
  accessKey: r.string,
  disabled: r.bool,
  readonly: r.bool,
  prompt: r.string,
  promptPlaceholder: r.string,
  includeLiterals: r.bool,
  maskValidation: r.bool,
  mask: r.string,
  rules: function(a, t, e) {
    const s = a.rules;
    return s !== void 0 && !Object.entries(s).some((i) => typeof i != "string" || !(s[i] instanceof RegExp)) ? new Error(
      "Invalid prop `" + t + "` supplied to `" + e + "`. Validation failed."
    ) : null;
  },
  selection: r.shape({
    start: r.number.isRequired,
    end: r.number.isRequired
  }),
  name: r.string,
  label: r.string,
  validationMessage: r.string,
  required: r.bool,
  valid: r.bool,
  validityStyles: r.bool,
  onChange: r.func,
  size: r.oneOf([null, "small", "medium", "large"]),
  rounded: r.oneOf([null, "small", "medium", "large", "full"]),
  fillMode: r.oneOf([null, "solid", "flat", "outline"])
};
yt.defaultProps = {
  prompt: "_",
  promptPlaceholder: " ",
  includeLiterals: !1,
  maskValidation: !0,
  rules: wn,
  required: !1,
  validityStyles: !0,
  prefix: (a) => null,
  suffix: (a) => null,
  size: "medium",
  rounded: "medium",
  fillMode: "solid"
};
const As = he(), $s = et(Ue(As, yt));
$s.displayName = "KendoReactMaskedTextBox";
var X = /* @__PURE__ */ ((a) => (a.start = "start", a.end = "end", a.min = "min", a.max = "max", a.increase = "increase", a.decrease = "decrease", a))(X || {});
const Hs = (a, t) => {
  let e, s;
  switch (t.type) {
    case "start":
      if (t.payload === void 0)
        return a;
      e = {
        start: t.payload > a.end ? a.end : Math.max(t.payload, t.min),
        end: a.end
      };
      break;
    case "end":
      if (t.payload === void 0)
        return a;
      e = {
        start: a.start,
        end: t.payload < a.start ? a.start : Math.min(t.payload, t.max)
      };
      break;
    case "min":
      t.key === "start" ? e = {
        ...a,
        start: t.min
      } : e = {
        ...a,
        end: Math.max(t.min, a.start)
      };
      break;
    case "max":
      t.key === "start" ? e = {
        ...a,
        start: Math.min(t.max, a.end)
      } : e = {
        ...a,
        end: t.max
      };
      break;
    case "increase":
      if (t.step === void 0 || t.key === void 0)
        return a;
      s = a[t.key] + t.step, t.key === "start" ? s < t.min ? e = {
        ...a,
        start: t.min
      } : e = {
        ...a,
        start: Math.min(s, a.end)
      } : s > t.max ? e = {
        ...a,
        end: t.max
      } : e = {
        ...a,
        end: Math.max(s, a.start)
      };
      break;
    case "decrease":
      if (t.step === void 0 || t.key === void 0)
        return a;
      s = a[t.key] - t.step, t.key === "start" ? s < t.min ? e = {
        ...a,
        start: t.min
      } : e = {
        ...a,
        start: Math.min(s, a.end)
      } : s > t.max ? e = {
        ...a,
        end: t.max
      } : e = {
        ...a,
        end: Math.max(s, a.start)
      };
      break;
    default:
      e = a;
      break;
  }
  return e;
}, Gs = (a, t, e) => {
  const [s, l] = n.useState(a), i = n.useCallback(
    (c) => {
      const o = Hs(t.state || s, { ...c, ...t });
      e && e(o, c.event), l(o);
    },
    [t, e]
  );
  return [s, i];
}, Ks = he(), ba = n.forwardRef((a, t) => {
  pe(me);
  const e = Re(Ks, a), s = n.useRef(null), l = n.useRef(null), i = n.useRef(null), c = n.useRef(null), o = n.useRef(null), f = n.useCallback(
    () => {
      c.current && c.current.focus();
    },
    [c]
  );
  n.useImperativeHandle(s, () => ({
    element: l.current,
    focus: f,
    props: e
  })), n.useImperativeHandle(t, () => s.current);
  const d = n.useMemo(
    () => e.min,
    [e.min]
  ), m = n.useMemo(
    () => e.max,
    [e.max]
  ), u = n.useMemo(
    () => e.step !== void 0 ? e.step : ut.step,
    [e.step, ut.step]
  ), h = Ae(l, e.dir), y = (g, k) => {
    e.onChange && s.current && e.onChange.call(void 0, {
      value: g,
      target: s.current,
      syntheticEvent: k
    });
  }, [M, D] = n.useState(""), [N, L] = Gs(
    e.defaultValue || ut.defaultValue,
    {
      min: d,
      max: m,
      step: u,
      state: e.value
    },
    y
  ), S = n.useMemo(
    () => e.value || N,
    [e.value, N]
  ), w = n.useRef(null), B = n.useRef(null), O = n.useMemo(
    () => (S.start - d) / (m - d) * 100,
    [S.start, d, m]
  ), I = n.useMemo(
    () => (S.end - d) / (m - d) * 100,
    [S.end, d, m]
  ), F = n.useMemo(
    () => e.vertical ? { paddingTop: 0, height: "100%" } : {},
    [e.vertical]
  ), _ = n.useMemo(
    () => e.vertical ? { marginTop: "0.5rem", marginBottom: "0.5rem" } : { marginLeft: "0.5rem", marginRight: "0.5rem" },
    [e.vertical]
  ), T = _e(), E = n.useCallback(
    (g) => {
      if (!B.current)
        return;
      const k = B.current.getBoundingClientRect(), C = e.vertical ? k.bottom - g.clientY : h === "rtl" ? k.right - g.clientX : g.clientX - k.left, P = e.vertical ? k.height : k.width, j = C / P;
      return d + j * (m - d);
    },
    [
      B,
      e.vertical,
      h,
      d,
      m,
      N.start,
      N.end,
      e.value && e.value.start,
      e.value && e.value.end
    ]
  ), V = n.useCallback(
    (g) => g <= S.start ? "start" : g >= S.end ? "end" : 2 * g < S.end + S.start ? "start" : "end",
    [
      N.start,
      N.end,
      e.value && e.value.start,
      e.value && e.value.end
    ]
  ), H = n.useCallback(
    (g) => {
      switch (g.keyCode) {
        case z.right:
          g.preventDefault(), L({ type: h === "rtl" ? X.decrease : X.increase, key: "start", event: g });
          break;
        case z.up:
          g.preventDefault(), L({ type: X.increase, key: "start", event: g });
          break;
        case z.left:
          g.preventDefault(), L({ type: h === "rtl" ? X.increase : X.decrease, key: "start", event: g });
          break;
        case z.down:
          g.preventDefault(), L({ type: X.decrease, key: "start", event: g });
          break;
        case z.home:
          g.preventDefault(), L({ type: X.min, key: "start", event: g });
          break;
        case z.end:
          g.preventDefault(), L({ type: X.max, key: "start", event: g });
          break;
      }
    },
    [L]
  ), q = n.useCallback(
    (g) => {
      switch (g.keyCode) {
        case z.right:
          g.preventDefault(), L({ type: h === "rtl" ? X.decrease : X.increase, key: "end", event: g });
          break;
        case z.up:
          g.preventDefault(), L({ type: X.increase, key: "end", event: g });
          break;
        case z.left:
          g.preventDefault(), L({ type: h === "rtl" ? X.increase : X.decrease, key: "end", event: g });
          break;
        case z.down:
          g.preventDefault(), L({ type: X.decrease, key: "end", event: g });
          break;
        case z.home:
          g.preventDefault(), L({ type: X.min, key: "end", event: g });
          break;
        case z.end:
          g.preventDefault(), L({ type: X.max, key: "end", event: g });
          break;
      }
    },
    [L, h]
  ), Z = n.useCallback(
    (g) => {
      const k = E(g), C = V(k);
      D(C), C === "end" ? o.current.focus() : c.current.focus();
      const P = C === "end" ? X.end : X.start;
      L({ type: P, payload: k, event: g });
    },
    [e.vertical, d, m, L]
  );
  return Pn(B, { onPress: Z, onDrag: (g) => {
    const k = E(g), C = M === "end" ? X.end : X.start;
    L({ type: C, payload: k, event: g });
  }, onRelease: (g) => {
    const k = E(g), C = M === "end" ? X.end : X.start;
    L({ type: C, payload: k, event: g }), D("");
  } }), /* @__PURE__ */ n.createElement(
    "div",
    {
      id: e.id,
      style: e.style,
      ref: l,
      dir: h,
      className: G(
        "k-slider",
        {
          "k-rtl": h === "rtl",
          "k-disabled": e.disabled,
          "k-slider-vertical": e.vertical,
          "k-slider-horizontal": !e.vertical
        },
        e.className
      )
    },
    /* @__PURE__ */ n.createElement(
      "div",
      {
        ref: B,
        className: "k-slider-track-wrap",
        style: {
          flexGrow: 1,
          position: "relative",
          touchAction: "none",
          ..._
        }
      },
      e.children && /* @__PURE__ */ n.createElement(
        "ul",
        {
          className: "k-reset k-slider-items",
          style: { ...F }
        },
        n.Children.map(e.children, (g) => g && n.cloneElement(
          g,
          {
            position: 100 * (g.props.position - e.min) / (e.max - e.min),
            vertical: e.vertical
          },
          g.props.children
        ))
      ),
      /* @__PURE__ */ n.createElement(
        "div",
        {
          ref: w,
          className: "k-slider-track",
          style: e.vertical ? { bottom: 0, height: "100%" } : { [h === "rtl" ? "right" : "left"]: 0, width: "100%" }
        },
        O !== null && I !== null && /* @__PURE__ */ n.createElement(
          "div",
          {
            "data-selection": !0,
            ref: i,
            title: `${S.start} - ${S.end}`,
            className: "k-slider-selection",
            style: e.vertical ? { height: I - O + "%", bottom: O + "%" } : {
              [h === "rtl" ? "right" : "left"]: O + "%",
              width: I - O + "%"
            }
          }
        ),
        /* @__PURE__ */ n.createElement(
          "span",
          {
            ref: c,
            role: "slider",
            tabIndex: ie(e.startTabIndex, e.disabled, void 0),
            "aria-valuemin": d,
            "aria-valuemax": Math.max(m, S.end),
            "aria-valuenow": S.start,
            "aria-disabled": e.disabled ? "true" : void 0,
            "aria-valuetext": `${S.start} - ${S.end}`,
            className: "k-draghandle",
            title: T.toLanguageString(Te, $[Te]),
            style: e.vertical ? { bottom: "calc(" + O + "%)", zIndex: 1 } : h === "rtl" ? { right: "calc(" + O + "% - 13px)", zIndex: 1 } : { left: "calc(" + O + "%)", zIndex: 1 },
            onKeyDown: H
          }
        ),
        /* @__PURE__ */ n.createElement(
          "span",
          {
            ref: o,
            role: "slider",
            tabIndex: ie(e.endTabIndex, e.disabled, void 0),
            "aria-valuemin": Math.min(d, S.start),
            "aria-valuemax": m,
            "aria-valuenow": S.end,
            "aria-disabled": e.disabled ? "true" : void 0,
            "aria-valuetext": `${S.start} - ${S.end}`,
            className: "k-draghandle",
            title: T.toLanguageString(Te, $[Te]),
            style: e.vertical ? { bottom: "calc(" + I + "%)", zIndex: 1 } : h === "rtl" ? { right: "calc(" + I + "% - 13px)", zIndex: 1 } : { left: "calc(" + I + "%)", zIndex: 1 },
            onKeyDown: q
          }
        )
      )
    )
  );
}), qs = {
  value: (a, t, e) => {
    if (a.value) {
      const s = a.value.start, l = a.value.end, i = a.min, c = a.max;
      if (s > l || s > c || s < i || l > c || l < i || l < s)
        return new Error(
          `Invalid prop + ${t} supplied to ${e}.
                    The { start, end } value must be between the min & max value and { start, end } must be start < end.
                    `
        );
    }
    return null;
  },
  defaultValue: (a, t, e) => {
    if (a.defaultValue) {
      const s = a.defaultValue.start, l = a.defaultValue.end, i = a.min, c = a.max;
      if (s > l || s > c || s < i || l > c || l < i || l < s)
        return new Error(
          `Invalid prop + ${t} supplied to ${e}.
                    The { start, end } value must be between the min & max value and { start, end } must be start < end.
                    `
        );
    }
    return null;
  },
  onChange: r.func,
  step: r.number,
  min: (a, t, e) => {
    const s = a[t], l = a.min, i = a.max;
    return l === void 0 ? new Error(
      `Invalid prop + ${t} supplied to ${e}.
                ${t} value can not be undefined.
                `
    ) : s && l >= i ? new Error(
      `Invalid prop + ${t} supplied to ${e}.
                ${t} value can not be equal to or bigger than the max value.
                `
    ) : null;
  },
  max: (a, t, e) => {
    const s = a[t], l = a.min, i = a.max;
    return i === void 0 ? new Error(
      `Invalid prop + ${t} supplied to ${e}.
                ${t} value can not be undefined.
                `
    ) : s && i <= l ? new Error(
      `Invalid prop + ${t} supplied to ${e}.
                ${t} value can not be equal to or smaller than the min value.
                `
    ) : null;
  },
  vertical: r.bool,
  disabled: r.bool,
  dir: r.oneOf(["ltr", "rtl"])
}, ut = {
  step: 1,
  defaultValue: {
    start: 0,
    end: 0
  },
  vertical: !1,
  disabled: !1
};
ba.displayName = "KendoReactRangeSlider";
ba.propTypes = qs;
ba.defaultProps = ut;
const ft = class extends n.Component {
  /**
   * @hidden
   */
  constructor(a) {
    super(a), this.setValidity = () => {
      this._input && this._input.setCustomValidity && this._input.setCustomValidity(
        this.validity.valid ? "" : this.props.validationMessage || this.defaultValidationMessage.toLanguageString(Jt, $[Jt])
      );
    }, this.limit = (t, e, s) => {
      const l = s.offsetWidth, i = e.offsetWidth;
      return t < 0 ? 0 : t > l - i ? l - i : t;
    }, this.toggle = (t, e) => {
      this.setState({ checked: t }), this.valueDuringOnChange = t, Q(this.props.onChange, e, this, { value: t }), this.valueDuringOnChange = void 0;
    }, this._element = null, this._wrapper = null, this._input = null, this._id = this.props.id, this.defaultValidationMessage = Je(this), this.focus = () => {
      this.actionElement && this.actionElement.focus();
    }, this.dummyInput = (t) => /* @__PURE__ */ n.createElement(
      "input",
      {
        type: "checkbox",
        checked: this.props.checked,
        ref: (e) => {
          this._input = e;
        },
        tabIndex: -1,
        "aria-hidden": !0,
        value: t,
        style: { opacity: 0, width: 1, border: 0, zIndex: -1, position: "absolute", left: "50%" },
        onChange: Me,
        name: this.name || void 0
      }
    ), this.handleClick = (t) => {
      this.eventTimeStamp !== t.timeStamp && (this.eventTimeStamp = t.timeStamp, this.toggle(!this.value, t));
    }, this.handleKeyDown = (t) => {
      if (this.props.disabled)
        return;
      const { keyCode: e } = t;
      (e === z.space || e === z.enter) && (this.toggle(!this.value, t), t.preventDefault());
    }, this.handleWrapperFocus = (t) => {
      if (this.props.disabled)
        return;
      this.setState({ focused: !0 });
      const { onFocus: e } = this.props;
      e && e.call(void 0, t);
    }, this.handleWrapperBlur = (t) => {
      if (this.props.disabled)
        return;
      this.setState({ focused: !1 });
      const { onBlur: e } = this.props;
      e && e.call(void 0, t);
    }, pe(me), this.state = {
      checked: a.defaultChecked || ft.defaultProps.defaultChecked,
      focused: !1
    };
  }
  /**
   * Gets the value of the Switch.
   */
  get value() {
    return this.valueDuringOnChange !== void 0 ? this.valueDuringOnChange : this.props.checked !== void 0 ? this.props.checked : this.state.checked;
  }
  get element() {
    return this._element;
  }
  get actionElement() {
    return this._wrapper;
  }
  /**
   * Gets the `name` property of the Switch.
   */
  get name() {
    return this.props.name;
  }
  /**
   * Represents the validity state into which the Switch is set.
   */
  get validity() {
    const a = this.props.validationMessage !== void 0, t = this.props.valid !== void 0 ? this.props.valid : this.props.required ? !!this.value : !0, e = this.props.valid !== void 0 ? this.props.valid : t;
    return {
      customError: a,
      valid: e,
      valueMissing: this.value === null
    };
  }
  /**
   * @hidden
   */
  get validityStyles() {
    return this.props.validityStyles !== void 0 ? this.props.validityStyles : ft.defaultProps.validityStyles;
  }
  /**
   * @hidden
   */
  get required() {
    return this.props.required !== void 0 ? this.props.required : ft.defaultProps.required;
  }
  /**
   * @hidden
   */
  componentDidMount() {
    this.setValidity(), this.forceUpdate();
  }
  /**
   * @hidden
   */
  componentDidUpdate() {
    this.setValidity();
  }
  /**
   * @hidden
   */
  render() {
    const { focused: a } = this.state, { dir: t, disabled: e, trackRounded: s, thumbRounded: l, size: i, offLabel: c, onLabel: o, tabIndex: f } = this.props;
    this.dir = t || this.element && getComputedStyle(this.element).direction || void 0;
    const d = !this.validityStyles || this.validity.valid, m = G(
      "k-switch",
      {
        [`k-switch-${ne.sizeMap[i] || i}`]: i,
        [`k-rounded-${ne.roundedMap[s] || s}`]: s,
        "k-switch-on": this.value,
        "k-switch-off": !this.value,
        "k-focus": a,
        "k-disabled": e,
        "k-invalid": !d
      },
      this.props.className
    ), u = {
      "aria-checked": this.value,
      "aria-disabled": e || void 0,
      "aria-labelledby": this.props.ariaLabelledBy,
      "aria-describedby": this.props.ariaDescribedBy,
      "aria-label": this.props.ariaLabel
    };
    return /* @__PURE__ */ n.createElement(
      "span",
      {
        ref: (h) => {
          this._wrapper = h;
        },
        role: "switch",
        ...u,
        className: m,
        dir: this.dir,
        onKeyDown: this.handleKeyDown,
        onClick: this.handleClick,
        onBlur: this.handleWrapperBlur,
        onFocus: this.handleWrapperFocus,
        tabIndex: ie(f, e, void 0),
        accessKey: this.props.accessKey,
        id: this.props.id || this._id
      },
      /* @__PURE__ */ n.createElement(
        "span",
        {
          className: G(
            "k-switch-track",
            { [`k-rounded-${ne.roundedMap[s] || s}`]: s }
          ),
          ref: (h) => {
            this._element = h;
          }
        },
        this.dummyInput(this.value),
        /* @__PURE__ */ n.createElement("span", { className: "k-switch-label-on" }, o),
        /* @__PURE__ */ n.createElement("span", { className: "k-switch-label-off" }, c)
      ),
      /* @__PURE__ */ n.createElement("span", { className: "k-switch-thumb-wrap" }, /* @__PURE__ */ n.createElement("span", { className: G("k-switch-thumb", { [`k-rounded-${l}`]: l }) }))
    );
  }
};
let Ct = ft;
Ct.displayName = "Switch";
Ct.propTypes = {
  accessKey: r.string,
  checked: r.bool,
  className: r.string,
  disabled: r.bool,
  defaultChecked: r.bool,
  size: r.oneOf([null, "small", "medium", "large"]),
  trackRounded: r.oneOf([null, "small", "medium", "large", "full"]),
  thumbRounded: r.oneOf([null, "small", "medium", "large", "full"]),
  dir: r.string,
  id: r.string,
  ariaLabelledBy: r.string,
  ariaDescribedBy: r.string,
  offLabel: r.string,
  required: r.bool,
  tabIndex: r.number,
  valid: r.bool,
  validate: r.bool,
  validationMessage: r.string,
  onBlur: r.any,
  onChange: r.any,
  onFocus: r.any,
  onLabel: r.string
};
Ct.defaultProps = {
  disabled: !1,
  defaultChecked: !1,
  size: "medium",
  trackRounded: "full",
  thumbRounded: "full",
  offLabel: "OFF",
  onBlur: Me,
  onFocus: Me,
  onLabel: "ON",
  required: !1,
  validityStyles: !0
};
const Us = he(), js = et(Ue(Us, Ct));
js.displayName = "KendoReactSwitch";
const Ws = he(), va = n.forwardRef((a, t) => {
  pe(me);
  const e = Re(Ws, a), {
    ariaDescribedBy: s,
    ariaLabelledBy: l,
    checked: i,
    className: c,
    labelClassName: o,
    children: f,
    defaultChecked: d,
    disabled: m,
    defaultValue: u,
    id: h,
    size: y,
    rounded: M,
    label: D,
    labelPlacement: N,
    name: L,
    labelOptional: S,
    onChange: w,
    onFocus: B,
    onBlur: O,
    tabIndex: I,
    value: F,
    required: _,
    valid: T,
    validationMessage: E,
    validityStyles: V,
    // Removed to support direct use in Form Field component
    visited: H,
    touched: q,
    modified: Z,
    ...p
  } = e, v = n.useRef(null), g = n.useCallback(
    () => {
      v.current && v.current.focus();
    },
    []
  ), k = n.useCallback(
    () => ({
      element: v.current,
      focus: g,
      get name() {
        return v.current && v.current.name;
      }
    }),
    [g]
  );
  n.useImperativeHandle(t, k);
  const [C, P] = n.useState(d), [j, J] = n.useState(u), R = typeof F == "boolean" || F === null, b = i !== void 0, W = R, K = W ? F : j, ee = b ? i : W ? void 0 : C, le = ee === void 0 && K, Ee = le ? K : ee, oe = le || W ? F === null ? F : void 0 : F || K, ce = Ee === null || oe === null, be = Qe(), He = _e(), A = (te) => He.toLanguageString(te, $[te]), xe = A(dn), ve = A(un), je = T !== void 0 ? T : _ ? !!ee : !0;
  n.useEffect(
    () => {
      v.current && v.current.setCustomValidity && v.current.setCustomValidity(
        je ? "" : E || xe
      );
    },
    [je, E, xe]
  );
  const De = n.useCallback(
    (te, we) => {
      !W && !m && (J(we), !b && !m && P(we)), w && !m && Q(
        w,
        te,
        {
          ...k(),
          value: we
        },
        { value: we }
      );
    },
    [b, m, w, W, k]
  ), wt = n.useCallback(
    (te) => {
      let we = te.target.checked;
      De(te, we);
    },
    [De, F]
  ), tt = n.useCallback(
    (te) => {
      if (m)
        return;
      const { keyCode: we } = te;
      let Vn = te.currentTarget.checked;
      we === z.space && (te.preventDefault(), te.stopPropagation(), De(te, !Vn));
    },
    [m, De]
  ), at = n.useCallback(
    (te) => {
      if (m)
        return;
      const { keyCode: we } = te;
      we === z.space && te.preventDefault();
    },
    [m]
  ), It = n.useCallback(
    (te) => {
      B && !m && Q(
        B,
        te,
        k(),
        void 0
      );
    },
    [B, m, k]
  ), x = n.useCallback(
    (te) => {
      O && !m && Q(
        O,
        te,
        k(),
        void 0
      );
    },
    [O, m, k]
  ), U = Ae(v, e.dir), re = G(
    "k-checkbox-wrap",
    c
  ), Se = {
    type: "checkbox",
    className: G(
      "k-checkbox",
      {
        [`k-checkbox-${ne.sizeMap[y] || y}`]: y,
        [`k-rounded-${ne.roundedMap[M] || M}`]: M,
        "k-indeterminate": ce,
        "k-disabled": m,
        "k-invalid k-invalid": !(je || V !== void 0 || V === !0)
      }
    ),
    ref: v,
    name: L,
    id: h || be,
    "aria-labelledby": l,
    "aria-describedby": s,
    checked: !!Ee,
    disabled: m,
    tabIndex: ie(I, m),
    role: "checkbox",
    required: _ !== void 0 ? _ : !1,
    "aria-checked": ee || Ee ? !0 : ce ? "mixed" : !1,
    "aria-disabled": m || void 0,
    ...p,
    onChange: wt,
    onKeyDown: tt,
    onKeyUp: at,
    onFocus: It,
    onBlur: x
  }, Ea = /* @__PURE__ */ n.createElement(
    n.Fragment,
    null,
    // removing value prop is required due to bug in react where
    // value set to undefined override default submit value
    oe === void 0 ? /* @__PURE__ */ n.createElement("input", { ...Se }) : /* @__PURE__ */ n.createElement("input", { ...Se, value: R ? void 0 : oe === null ? "" : oe })
  ), Sa = /* @__PURE__ */ n.createElement(n.Fragment, null, D !== void 0 ? /* @__PURE__ */ n.createElement(
    "label",
    {
      className: G("k-checkbox-label", o),
      htmlFor: h || be,
      style: { userSelect: "none" }
    },
    D,
    S && /* @__PURE__ */ n.createElement("span", { className: "k-label-optional" }, ve)
  ) : null);
  return /* @__PURE__ */ n.createElement(n.Fragment, null, N === "before" ? /* @__PURE__ */ n.createElement("span", { className: re, dir: "rtl" }, Ea, Sa, f) : /* @__PURE__ */ n.createElement("span", { className: re, dir: U }, Ea, Sa, f));
});
va.propTypes = {
  checked: r.bool,
  className: r.string,
  defaultChecked: r.bool,
  defaultValue: r.any,
  dir: r.string,
  disabled: r.bool,
  id: r.string,
  size: r.oneOf([null, "small", "medium", "large"]),
  rounded: r.oneOf([null, "small", "medium", "large"]),
  ariaLabelledBy: r.string,
  ariaDescribedBy: r.string,
  label: r.any,
  labelPlacement: r.string,
  labelOptional: r.bool,
  name: r.string,
  tabIndex: r.number,
  value: r.any,
  validationMessage: r.string,
  required: r.bool,
  validate: r.bool,
  valid: r.bool,
  onChange: r.func,
  onFocus: r.func,
  onBlur: r.func
};
const Xs = {
  size: "medium",
  rounded: "medium"
};
va.defaultProps = Xs;
va.displayName = "KendoCheckbox";
const Ys = he(), xt = n.forwardRef((a, t) => {
  pe(me);
  const e = Re(Ys, a), {
    ariaDescribedBy: s,
    checked: l,
    children: i,
    className: c,
    disabled: o,
    id: f,
    size: d,
    label: m,
    labelPlacement: u,
    name: h,
    style: y,
    tabIndex: M,
    value: D,
    valid: N,
    onChange: L,
    onFocus: S,
    onBlur: w,
    ...B
  } = e, O = n.useRef(null), I = n.useCallback(
    () => {
      O.current && O.current.focus();
    },
    []
  ), F = n.useCallback(
    () => ({
      element: O.current,
      focus: I
    }),
    [I]
  );
  n.useImperativeHandle(t, F);
  const _ = Qe(), T = n.useCallback(
    (p) => {
      Q(
        L,
        p,
        F(),
        { value: D }
      );
    },
    [L, D, o]
  ), E = n.useCallback(
    (p) => {
      S && !o && Q(
        S,
        p,
        F(),
        void 0
      );
    },
    [S, o]
  ), V = n.useCallback(
    (p) => {
      w && !o && Q(
        w,
        p,
        F(),
        void 0
      );
    },
    [w, o]
  ), H = {
    type: "radio",
    id: f || _,
    name: h,
    className: G(
      "k-radio",
      {
        [`k-radio-${ne.sizeMap[d] || d}`]: d,
        "k-invalid": N === !1
      },
      c
    ),
    ref: O,
    disabled: o,
    tabIndex: ie(M, o),
    checked: l,
    style: y,
    "aria-describedby": s,
    value: D,
    onChange: T,
    onFocus: E,
    onBlur: V,
    ...B
  }, q = /* @__PURE__ */ n.createElement(n.Fragment, null, m !== void 0 ? /* @__PURE__ */ n.createElement(
    "label",
    {
      className: "k-radio-label",
      htmlFor: f || _,
      style: { userSelect: "none" },
      "aria-label": m
    },
    m
  ) : null), Z = /* @__PURE__ */ n.createElement("input", { ...H });
  return u === "before" ? /* @__PURE__ */ n.createElement(n.Fragment, null, q, Z, i) : /* @__PURE__ */ n.createElement(n.Fragment, null, Z, q, i);
});
xt.propTypes = {
  ariaDescribedBy: r.string,
  checked: r.bool,
  className: r.string,
  disabled: r.bool,
  id: r.string,
  size: r.oneOf([null, "small", "medium", "large"]),
  label: r.string,
  labelPlacement: r.string,
  name: r.string,
  style: r.object,
  tabIndex: r.number,
  value: r.any,
  valid: r.bool,
  onChange: r.func,
  onFocus: r.func,
  onBlur: r.func
};
const Zs = {
  size: "medium"
};
xt.displayName = "KendoRadioButton";
xt.defaultProps = Zs;
const Js = he(), ka = n.forwardRef((a, t) => {
  pe(me);
  const e = Re(Js, a), {
    id: s,
    ariaLabelledBy: l,
    ariaDescribedBy: i,
    className: c,
    data: o,
    defaultValue: f,
    disabled: d,
    name: m,
    labelPlacement: u,
    layout: h,
    style: y,
    value: M,
    valid: D,
    item: N = In.item,
    onChange: L,
    onFocus: S
  } = e, w = n.useRef(null), B = n.useCallback(
    () => {
      w.current && tn(w.current);
    },
    []
  ), O = n.useCallback(
    () => ({
      element: w.current,
      focus: B
    }),
    [B]
  );
  n.useImperativeHandle(t, O);
  const [I, F] = n.useState(f), _ = M !== void 0, T = _ ? M : I, E = n.useCallback(
    (v) => {
      let g = v.value;
      !_ && !d && F(g), L && !d && Q(
        L,
        v.syntheticEvent,
        O(),
        { value: g }
      );
    },
    [F, L, d]
  ), V = n.useCallback(
    (v) => {
      S && !d && Q(
        S,
        v.syntheticEvent,
        O(),
        void 0
      );
    },
    [S, d]
  ), H = Qe(), q = G(
    "k-radio-list",
    {
      "k-list-horizontal": h === "horizontal",
      "k-list-vertical": h === "vertical" || h === void 0
    },
    c
  ), Z = Dn(w, e.dir), p = o && o.map((v, g) => {
    const k = T === v.value, C = T == null, P = {
      ...v,
      valid: D,
      checked: k,
      disabled: !!(v.disabled || d),
      labelPlacement: v.labelPlacement ? v.labelPlacement : u,
      tabIndex: v.tabIndex ? v.tabIndex : C && g === 0 || k ? 0 : -1,
      index: g,
      name: m || H,
      onChange: E,
      onFocus: V
    };
    return /* @__PURE__ */ n.createElement(
      N,
      {
        className: G("k-radio-item", { "k-disabled": P.disabled || d }),
        key: g,
        role: "none"
      },
      /* @__PURE__ */ n.createElement(xt, { ...P })
    );
  });
  return /* @__PURE__ */ n.createElement(
    "ul",
    {
      id: s,
      role: "radiogroup",
      className: q,
      ref: w,
      dir: Z,
      style: y,
      "aria-labelledby": l,
      "aria-describedby": i
    },
    p
  );
}), In = {
  item: (a) => /* @__PURE__ */ n.createElement("li", { ...a })
};
ka.propTypes = {
  ariaLabelledBy: r.string,
  ariaDescribedBy: r.string,
  className: r.string,
  data: r.arrayOf(r.object),
  defaultValue: r.any,
  dir: r.string,
  disabled: r.bool,
  labelPlacement: r.string,
  layout: r.string,
  name: r.string,
  style: r.object,
  value: r.any,
  onChange: r.func,
  onFocus: r.func
};
ka.defaultProps = In;
ka.displayName = "KendoRadioGroup";
const Qs = he(), ya = n.forwardRef((a, t) => {
  const e = Re(Qs, a), {
    size: s,
    rounded: l,
    fillMode: i,
    ariaDescribedBy: c,
    ariaLabelledBy: o,
    autoSize: f,
    className: d,
    defaultValue: m,
    disabled: u,
    readOnly: h,
    required: y,
    rows: M,
    id: D,
    name: N,
    placeholder: L,
    style: S,
    tabIndex: w,
    value: B,
    valid: O,
    validationMessage: I,
    validityStyles: F,
    onChange: _,
    onFocus: T,
    onBlur: E,
    // Removed to support direct use in Form Field component
    visited: V,
    touched: H,
    modified: q,
    ...Z
  } = e, p = n.useRef(null), v = n.useCallback(
    () => {
      p.current && p.current.focus();
    },
    []
  ), [g, k] = n.useState(m), C = B !== void 0, P = C ? B : g, j = n.useCallback(
    () => ({
      element: p,
      focus: v,
      get value() {
        return P;
      },
      get name() {
        return p.current && p.current.name;
      }
    }),
    [v, P]
  );
  n.useImperativeHandle(t, j);
  const [J, R] = n.useState("auto"), b = Qe(), W = Ae(p, e.dir), K = O !== void 0 ? O : y ? !!P : !0;
  n.useEffect(
    () => {
      p.current && p.current.setCustomValidity && p.current.setCustomValidity(
        K ? "" : I || ""
      );
    },
    [K, I]
  ), n.useLayoutEffect(
    () => {
      p.current && R(`${p.current.scrollHeight}px`);
    },
    [P]
  );
  const ee = n.useCallback(
    (ce) => {
      const be = ce.target.value;
      R("auto"), !C && !u && k(be), _ && !u && Q(
        _,
        ce,
        {
          ...j(),
          value: be
        },
        { value: be }
      );
    },
    [k, _, u, C]
  ), le = n.useCallback(
    (ce) => {
      T && !u && Q(
        T,
        ce,
        j(),
        void 0
      );
    },
    [T, u]
  ), Ee = n.useCallback(
    (ce) => {
      E && !u && Q(
        E,
        ce,
        j(),
        void 0
      );
    },
    [E, u]
  ), oe = {
    id: D || b,
    role: "textbox",
    name: N,
    className: "k-input-inner !k-overflow-auto",
    ref: p,
    disabled: u,
    rows: M,
    placeholder: L,
    readOnly: h,
    required: y,
    tabIndex: ie(w, u),
    style: f ? { resize: "none", overflow: "hidden", height: J } : {},
    "aria-labelledby": o,
    "aria-describedby": c,
    "aria-multiline": !0,
    "aria-disabled": u || void 0,
    value: C ? B : g,
    ...Z,
    onChange: ee,
    onFocus: le,
    onBlur: Ee
  };
  return /* @__PURE__ */ n.createElement(
    "span",
    {
      className: G(
        "k-input",
        "k-textarea",
        {
          [`k-input-${ne.sizeMap[s] || s}`]: s,
          [`k-input-${i}`]: i,
          [`k-rounded-${ne.roundedMap[l] || l}`]: l,
          "k-invalid": !(K || F !== void 0 || F === !0),
          "k-required": y,
          "k-disabled": u
        },
        d
      ),
      style: S,
      dir: W
    },
    /* @__PURE__ */ n.createElement("textarea", { ...oe })
  );
});
ya.propTypes = {
  ariaDescribedBy: r.string,
  ariaLabelledBy: r.string,
  autoSize: r.bool,
  className: r.string,
  defaultValue: r.string,
  dir: r.string,
  disabled: r.bool,
  readOnly: r.bool,
  rows: r.number,
  id: r.string,
  name: r.string,
  placeholder: r.string,
  style: r.object,
  tabIndex: r.number,
  value: r.oneOfType([
    r.string,
    r.arrayOf(r.string),
    r.number
  ]),
  onChange: r.func,
  onFocus: r.func,
  onBlur: r.func,
  size: r.oneOf([null, "small", "medium", "large"]),
  rounded: r.oneOf([null, "small", "medium", "large", "full"]),
  fillMode: r.oneOf([null, "solid", "flat", "outline"])
};
const er = {
  size: "medium",
  rounded: "medium",
  fillMode: "solid"
};
ya.displayName = "KendoTextArea";
ya.defaultProps = er;
const Et = n.forwardRef((a, t) => {
  const e = n.useRef(null), s = n.useRef(null), l = Ae(s, a.dir);
  n.useImperativeHandle(e, () => ({
    element: s.current,
    props: a,
    value: a.value
  })), n.useImperativeHandle(t, () => e.current);
  const i = n.useCallback(
    (h) => {
      a.onClick && a.onClick.call(
        void 0,
        {
          value: a.value,
          target: e.current,
          syntheticEvent: h
        }
      );
    },
    [a.onClick, a.value]
  ), c = n.useCallback(
    (h) => {
      a.onKeyDown && a.onKeyDown.call(
        void 0,
        {
          target: e.current,
          syntheticEvent: h
        }
      );
    },
    [a.onKeyDown]
  ), o = n.useCallback(
    (h) => {
      a.onFocus && a.onFocus.call(
        void 0,
        {
          target: e.current,
          syntheticEvent: h
        }
      );
    },
    [a.onFocus]
  ), f = n.useCallback(
    (h) => {
      a.onBlur && a.onBlur.call(
        void 0,
        {
          target: e.current,
          syntheticEvent: h
        }
      );
    },
    [a.onBlur]
  ), d = n.useCallback(
    (h) => {
      a.onMouseMove && a.onMouseMove.call(
        void 0,
        {
          target: e.current,
          syntheticEvent: h
        }
      );
    },
    [a.onMouseMove]
  ), m = n.useCallback(
    (h) => {
      a.onMouseEnter && a.onMouseEnter.call(
        void 0,
        {
          target: e.current,
          syntheticEvent: h
        }
      );
    },
    [a.onMouseEnter]
  ), u = n.useCallback(
    (h) => {
      a.onMouseLeave && a.onMouseLeave.call(
        void 0,
        {
          target: e.current,
          syntheticEvent: h
        }
      );
    },
    [a.onMouseLeave]
  );
  return /* @__PURE__ */ n.createElement(
    "span",
    {
      id: a.id,
      ref: s,
      dir: l,
      "data-half": a.half,
      tabIndex: a.tabIndex,
      title: a.title,
      style: a.style,
      className: G(
        "k-rating-item",
        {
          "k-rtl": l === "rtl",
          "k-selected": a.selected,
          "k-hover": a.hovered
        },
        a.className
      ),
      onClick: i,
      onKeyDown: c,
      onFocus: o,
      onBlur: f,
      onMouseEnter: m,
      onMouseLeave: u,
      onMouseMove: d
    },
    a.children
  );
}), tr = {
  id: r.string,
  icon: r.any,
  dir: r.oneOf(["ltr", "rtl"]),
  title: r.string,
  value: r.number,
  half: r.bool,
  selected: r.bool,
  hovered: r.bool
}, ar = {
  dir: "ltr"
};
Et.displayName = "KendoReactRatingItem";
Et.propTypes = tr;
Et.defaultProps = ar;
const ye = (a, t) => {
  if (a % 1) {
    const e = Math.pow(10, (t.toString().split(".")[1] || t.toString().split(".")[0]).length);
    return Math.round(a * e) / e;
  }
  return a;
}, nr = (a, t) => a - t * Math.floor(a / t), oa = (a, t, e) => ye(a - e, e) < t && t < a, Ot = (a, t, e, s) => t === null ? !1 : s === "continues" ? oa(a, t, e) ? ye(a - e / 2, e / 2) <= t : a <= t : s === "single" ? oa(a, t, e) ? ye(a - e / 2, e / 2) === t : a === t : !1, Ya = (a, t, e) => a === "ltr" ? e < t.x + t.width / 2 : e > t.x + t.width / 2, Za = (a, t, e, s) => {
  for (let l = a; l <= t; l += e)
    if (s === l)
      return !0;
  return !1;
};
var de = /* @__PURE__ */ ((a) => (a.select = "select", a.deselect = "deselect", a.increase = "increase", a.decrease = "decrease", a.min = "min", a.max = "max", a.reset = "reset", a))(de || {});
const sr = (a, t) => {
  switch (t.type) {
    case "select":
      return t.payload === void 0 || t.step === void 0 ? a : t.payload === a ? null : t.payload >= t.min ? t.payload < t.max ? ye(t.payload, t.step) : t.max : t.min;
    case "deselect":
      return null;
    case "increase":
      return t.step === void 0 ? a : a < t.min ? t.min : a + t.step < t.max ? ye(a + t.step, t.step) : t.max;
    case "decrease":
      return t.step === void 0 ? a : ye(a - t.step, t.step) >= t.min ? ye(a - t.step, t.step) : t.min;
    case "min":
      return t.step === void 0 ? a : t.min;
    case "max":
      return t.max;
    case "reset":
      return null;
    default:
      return a;
  }
}, Ja = (a, t, e) => {
  const [s, l] = n.useState(a);
  return [s, (c) => {
    const o = sr(t.state || s, { ...c, ...t });
    e && e(o, c.event), l(o);
  }];
}, rr = he(), Ca = n.forwardRef((a, t) => {
  const e = Re(rr, a), s = _e(), l = n.useRef(null), i = n.useRef(null), c = Ae(i, e.dir);
  n.useImperativeHandle(l, () => ({
    element: i.current,
    props: e
  })), n.useImperativeHandle(t, () => l.current);
  const o = n.useCallback(
    (p, v) => {
      e.onChange && l.current && e.onChange.call(void 0, {
        value: p,
        target: l.current,
        syntheticEvent: v
      });
    },
    [e.onChange]
  ), f = n.useMemo(
    () => e.min !== void 0 ? e.min : Ie.min,
    [e.min]
  ), d = n.useMemo(
    () => e.max !== void 0 ? e.max : Ie.max,
    [e.max]
  ), m = n.useMemo(
    () => e.precision || Ie.precision,
    [e.precision]
  ), u = n.useMemo(
    () => e.step !== void 0 ? e.step : Ie.step,
    [e.step]
  ), h = n.useMemo(
    () => e.readonly || Ie.readonly,
    [e.readonly]
  ), y = n.useMemo(
    () => e.disabled || Ie.disabled,
    [e.disabled]
  ), M = n.useMemo(
    () => e.item || Ie.item,
    [e.item]
  ), [D, N] = Ja(
    e.defaultValue !== void 0 ? e.defaultValue : Ie.defaultValue,
    {
      state: e.value,
      min: f,
      max: d,
      step: m === "half" ? u / 2 : u
    },
    o
  ), [L, S] = Ja(
    null,
    {
      state: e.value,
      min: f,
      max: d,
      step: m === "half" ? u / 2 : u,
      precision: m
    }
  ), w = n.useMemo(
    () => e.value !== void 0 ? e.value : D,
    [e.value, D]
  ), B = n.useMemo(
    () => L,
    [L]
  ), O = n.useMemo(
    () => e.selection || Ie.selection,
    [e.selection]
  ), I = n.useMemo(
    () => u / (m === "half" ? 2 : 1),
    [u, m]
  ), F = n.useCallback(
    (p) => {
      if (!(!p.target || !p.target.element || h || y)) {
        if (m === "half") {
          const v = p.target.element.getBoundingClientRect(), k = Ya(c || "ltr", v, p.syntheticEvent.clientX) ? ye(p.target.value - u / 2, I) : p.target.value;
          N({ type: de.select, payload: k, event: p.syntheticEvent });
        } else
          N({ type: de.select, payload: p.target.value, event: p.syntheticEvent });
        if (e.onClick) {
          const v = {
            value: w,
            target: l.current,
            syntheticEvent: p.syntheticEvent
          };
          e.onClick.call(void 0, v);
        }
      }
    },
    [e.onClick, N, w]
  ), _ = n.useCallback(
    (p) => {
      if (!(h || y)) {
        switch (p.keyCode) {
          case z.right:
            p.preventDefault(), N({
              type: c === "rtl" ? de.decrease : de.increase,
              event: p
            });
            break;
          case z.left:
            p.preventDefault(), N({
              type: c === "rtl" ? de.increase : de.decrease,
              event: p
            });
            break;
          case z.home:
            p.preventDefault(), N({
              type: c === "rtl" ? de.min : de.max,
              event: p
            });
            break;
          case z.end:
            p.preventDefault(), N({
              type: c === "rtl" ? de.max : de.min,
              event: p
            });
            break;
          case z.esc:
            p.preventDefault(), N({
              type: de.deselect,
              event: p
            });
            break;
        }
        e.onKeyDown && e.onKeyDown.call(
          void 0,
          {
            value: w,
            target: l.current,
            syntheticEvent: p
          }
        );
      }
    },
    [e.onKeyDown, N, w]
  ), T = n.useCallback(
    (p) => {
      if (e.onFocus) {
        const v = {
          target: l.current,
          syntheticEvent: p
        };
        e.onFocus.call(
          void 0,
          v
        );
      }
    },
    [e.onFocus]
  ), E = n.useCallback(
    (p) => {
      if (e.onBlur) {
        const v = {
          target: l.current,
          syntheticEvent: p
        };
        e.onBlur.call(
          void 0,
          v
        );
      }
    },
    [e.onBlur]
  ), V = n.useCallback(
    (p) => {
      if (!(!p.target || !p.target.element))
        if (m === "half") {
          const v = p.target.element.getBoundingClientRect(), k = Ya(c || "ltr", v, p.syntheticEvent.clientX) ? p.target.value - u / 2 : p.target.value;
          S({ type: de.select, payload: k, event: p.syntheticEvent });
        } else
          S({ type: de.select, payload: p.target.value, event: p.syntheticEvent });
    },
    [m, u, c]
  ), H = n.useCallback(
    (p) => {
      S({ type: de.reset, event: p.syntheticEvent });
    },
    []
  ), q = [], Z = nr(ye(d - f, I), u);
  for (let p = f; p <= d; p = ye(p + u, I)) {
    const v = ye(p + Z, I), g = m === "half" ? oa(v, B !== null ? B : w !== null ? w : 0, u) : !1, k = Ot(v, w, u, O), C = Ot(v, B !== null ? B : w, u, O), P = Ot(v, B, u, O);
    q.push(
      /* @__PURE__ */ n.createElement(
        M,
        {
          key: v,
          value: v,
          dir: c,
          title: String(g ? ye(v - u / 2, I) : v),
          icon: e.icon,
          svgIcon: e.svgIcon,
          half: g,
          selected: k || C,
          hovered: P,
          onClick: F,
          onMouseMove: V,
          onMouseLeave: H
        },
        g && /* @__PURE__ */ n.createElement("span", { className: "k-rating-precision-complement" }, !(e.icon || e.svgIconOutline) && /* @__PURE__ */ n.createElement(fe, { name: "star-outline", icon: Ra, style: { clipPath: `${c === "rtl" ? "inset(0 50% 0 0)" : "inset(0 0 0 50%)"}` }, size: "xlarge" }), (e.icon || e.svgIconOutline) && /* @__PURE__ */ n.createElement(fe, { name: Lt(`${e.icon}-outline`), icon: e.svgIconOutline, size: "xlarge" })),
        g && /* @__PURE__ */ n.createElement("span", { className: "k-rating-precision-part" }, !(e.icon || e.svgIcon) && /* @__PURE__ */ n.createElement(fe, { name: "star", icon: Va, style: { clipPath: `${c === "rtl" ? "inset(0 0 0 50%)" : "inset(0 50% 0 0)"}` }, size: "xlarge" }), (e.icon || e.svgIcon) && /* @__PURE__ */ n.createElement(fe, { name: e.icon ? Lt(e.icon) : void 0, icon: e.svgIcon, size: "xlarge" })),
        g && /* @__PURE__ */ n.createElement("span", { style: { width: "24px", height: "24px", display: "block" } }),
        !g && !(e.icon || e.svgIcon) && (P || C && !P) && /* @__PURE__ */ n.createElement(fe, { name: "star", icon: Va, size: "xlarge" }) || !(e.icon || e.svgIcon) && !P && !C && /* @__PURE__ */ n.createElement(fe, { name: "star-outline", icon: Ra, size: "xlarge" }) || (e.icon || e.svgIcon) && (P || C && !P) && /* @__PURE__ */ n.createElement(fe, { name: e.icon, icon: e.svgIcon, size: "xlarge" }) || (e.icon || e.svgIcon) && !P && /* @__PURE__ */ n.createElement(fe, { name: Lt(`${e.icon}-outline`), icon: e.svgIconOutline, size: "xlarge" })
      )
    );
  }
  return /* @__PURE__ */ n.createElement(
    "span",
    {
      id: e.id,
      style: e.style,
      ref: i,
      role: "slider",
      dir: c,
      tabIndex: ie(e.tabIndex, e.disabled, void 0),
      className: G(
        "k-rating",
        {
          "k-rtl": c === "rtl",
          "k-readonly": h,
          "k-disabled": y
        },
        e.className
      ),
      onKeyDown: _,
      onFocus: T,
      onBlur: E,
      "aria-valuemin": f,
      "aria-valuemax": d,
      "aria-valuenow": w !== null ? w : void 0,
      "aria-disabled": y ? "true" : void 0,
      "aria-label": s.toLanguageString(ea, $[ea]),
      "aria-labelledby": e.ariaLabelledBy,
      "aria-describedby": e.ariaDescribedBy
    },
    /* @__PURE__ */ n.createElement(
      "input",
      {
        id: "rating",
        className: "k-hidden",
        readOnly: h,
        disabled: y
      }
    ),
    /* @__PURE__ */ n.createElement(
      "span",
      {
        className: "k-rating-container"
      },
      q
    ),
    e.label && /* @__PURE__ */ n.createElement(
      "span",
      {
        className: "k-rating-label"
      },
      e.label
    )
  );
}), ir = {
  id: r.string,
  dir: r.oneOf(["ltr", "rtl"]),
  selection: r.oneOf(["continues", "single"]),
  precision: r.oneOf(["item", "half"]),
  value: (a, t, e) => a.value && a.min && a.max && a.step && !(a.precision === "half" ? Za(a.min, a.max, a.step / 2, a.value) : Za(a.min, a.max, a.step, a.value)) && a.precision === "half" ? new Error(
    `Invalid prop + ${t} supplied to ${e}.
                    The value of the { value } property is not correct, please check your values.
                    `
  ) : null,
  defaultValue: r.number,
  min: r.number,
  max: r.number,
  step: (a, t, e) => a.step !== void 0 && a.step <= 0 ? new Error(
    `Invalid prop + ${t} supplied to ${e}.
                The value of the { step } property is cannot be equal or less than "0", please check your values.
                `
  ) : null,
  hovered: r.number,
  label: r.string,
  readonly: r.bool,
  disabled: r.bool,
  half: r.bool,
  icon: r.string,
  svgIcon: Ft,
  svgIconOutline: Ft,
  ariaDescribedBy: r.string
}, Ie = {
  dir: "ltr",
  min: 1,
  max: 5,
  step: 1,
  item: Et,
  defaultValue: null,
  readonly: !1,
  disabled: !1,
  selection: "continues",
  precision: "item"
};
Ca.displayName = "KendoReactRating";
Ca.propTypes = ir;
Ca.defaultProps = Ie;
function lr(a, t) {
  let e = a;
  for (; e && e !== t; )
    e = e.parentNode;
  return !!e;
}
const or = 250, cr = 84, Ln = 3, Rn = 2, dr = "#000000", ur = "#ffffff", Qa = (a) => a !== void 0, fr = he(), St = n.forwardRef((a, t) => {
  pe(me);
  const e = Re(fr, a), s = _e(), l = n.useRef(null), i = n.useRef(null), c = n.useRef(null), o = n.useRef(null), f = n.useRef(null), [d, m] = n.useState(), [u, h] = n.useState(!1), [y, M] = n.useState(!1), [D, N] = n.useState(), [L, S] = n.useState(), B = Qa(e.value) ? e.value : D, [O, I] = n.useState(!1), F = Qa(e.open), _ = F ? e.open : O, T = !(e.maximized || y || !e.maximizable || e.disabled), E = e.maximized && !y, H = !(!(e.value || D) || y || e.readOnly || e.disabled), q = s.toLanguageString(aa, $[aa]), Z = s.toLanguageString(na, $[na]), p = s.toLanguageString(ta, $[ta]), v = e.popupScale || Ln, g = e.exportScale || Rn, k = (x) => {
    N(x), e.onChange && e.onChange({ value: x });
  }, C = (x) => {
    d == null || d.loadImage(x.value), k(x.value);
  };
  n.useEffect(() => {
    e.value !== D && (N(e.value), d == null || d.loadImage(e.value));
  }, [e.value]);
  const P = () => {
    d == null || d.clear(), k();
  }, j = n.useCallback(
    (x) => {
      F || I(x);
    },
    [F]
  ), J = (x) => {
    var U, re;
    De(x), (re = ((U = f.current) == null ? void 0 : U.element) || i.current) == null || re.focus();
  }, R = n.useCallback(() => {
    let x = dr;
    return !e.color && typeof document < "u" && l.current && (x = getComputedStyle(l.current).color), e.color || x;
  }, [e.color]), b = n.useCallback(() => {
    let x = ur;
    return !e.backgroundColor && typeof document < "u" && l.current && (x = getComputedStyle(l.current).backgroundColor), e.backgroundColor || x;
  }, [e.backgroundColor]), W = () => ({
    scale: e.maximized ? e.popupScale : 1,
    color: R(),
    backgroundColor: b(),
    strokeWidth: e.strokeWidth,
    smooth: e.smooth,
    readonly: e.readOnly
  }), K = async (x) => {
    const { width: U, height: re } = x;
    return await (d == null ? void 0 : d.exportImage({
      width: U * g,
      height: re * g
    }));
  };
  n.useEffect(() => {
    const x = i.current, U = new $n(x, W());
    return B && U.loadImage(B), m(U), () => U.destroy();
  }, []), n.useEffect(() => {
    d == null || d.setOptions({
      onChange: async () => k(await K(tt())),
      onDraw: () => M(!0),
      onDrawEnd: () => M(!1)
    });
  }, [d]), n.useLayoutEffect(
    () => d == null ? void 0 : d.setOptions(W()),
    [e.readOnly, e.color, e.backgroundColor, e.strokeWidth, e.smooth]
  ), n.useEffect(() => {
    var re, Se;
    const x = (Se = (re = c.current) == null ? void 0 : re.element) == null ? void 0 : Se.querySelector(".k-overlay");
    if (!x)
      return;
    const U = () => j(!1);
    return x.addEventListener("click", U), () => x.removeEventListener("click", U);
  }, [_]), n.useEffect(() => {
    if (!_ || typeof document > "u")
      return;
    const x = (U) => {
      U.keyCode === z.esc && j(!1);
    };
    return document.addEventListener("keydown", x), () => document.removeEventListener("keydown", x);
  }, [_]), n.useEffect(() => {
    var x, U;
    e.maximized && ((U = (x = o.current) == null ? void 0 : x.element) == null || U.focus());
  }, []);
  const ee = n.useCallback(
    () => {
      var x;
      return (x = i.current) == null ? void 0 : x.focus();
    },
    []
  ), le = n.useCallback(
    () => e.value,
    [e.value]
  ), Ee = n.useCallback(
    () => e.name,
    [e.name]
  ), oe = n.useCallback(
    () => e.required,
    [e.required]
  ), ce = n.useCallback(
    () => {
      const x = e.validationMessage !== void 0, re = !le(), Se = e.valid !== void 0 ? e.valid : !oe() || !re;
      return {
        customError: x,
        valid: Se,
        valueMissing: re
      };
    },
    [e.validationMessage, e.valid, le, oe]
  ), be = n.useCallback(
    () => e.validityStyles,
    [e.validityStyles]
  ), He = n.useCallback(
    () => e,
    [e]
  ), A = n.useCallback(
    () => {
      const x = {
        element: l.current,
        focus: ee
      };
      return Object.defineProperty(x, "name", { get: Ee }), Object.defineProperty(x, "value", { get: le }), Object.defineProperty(x, "validity", { get: ce }), Object.defineProperty(x, "validityStyles", { get: be }), Object.defineProperty(x, "required", { get: oe }), Object.defineProperty(x, "props", { get: He }), Object.defineProperty(x, "color", { get: R }), Object.defineProperty(x, "backgroundColor", { get: b }), x;
    },
    [Ee, le, ce, be, oe, ee, He, R, b]
  );
  n.useImperativeHandle(t, A);
  const xe = n.useCallback(
    (x) => {
      u || e.maximized || (h(!0), Q(
        e.onFocus,
        x,
        A(),
        {}
      ));
    },
    [u, e.onFocus, A]
  ), ve = n.useCallback(
    (x) => {
      lr(x.relatedTarget, l.current) || (h(!1), Q(
        e.onBlur,
        x,
        A(),
        {}
      ));
    },
    [u, e.onBlur, A]
  ), je = n.useCallback(
    async (x) => {
      S(await K(at())), j(!0), Q(
        e.onOpen,
        x,
        A(),
        {}
      );
    },
    [_, F, e.onOpen, e.value, D, A]
  ), De = n.useCallback(
    (x) => {
      j(!1), Q(
        e.onClose,
        x,
        A(),
        {}
      );
    },
    [_, F, e.onClose, A]
  ), wt = () => {
    P(), ee();
  }, tt = () => {
    var re, Se;
    const x = e.width || ((re = l.current) == null ? void 0 : re.offsetWidth) || or, U = e.height || ((Se = l.current) == null ? void 0 : Se.offsetHeight) || cr;
    return {
      width: x,
      height: U
    };
  }, at = () => {
    const { width: x, height: U } = tt();
    return {
      width: x * v,
      height: U * v
    };
  }, It = !be() || ce().valid;
  return /* @__PURE__ */ n.createElement(
    "div",
    {
      ref: l,
      dir: e.dir,
      style: { width: e.width, height: e.height, ...e.style },
      className: G(
        "k-input",
        "k-signature",
        {
          "k-signature-maximized": e.maximized,
          [`k-signature-${ne.sizeMap[e.size] || e.size}`]: e.size,
          [`k-input-${e.fillMode}`]: e.fillMode,
          [`k-rounded-${ne.roundedMap[e.rounded] || e.rounded}`]: e.rounded,
          "k-invalid": !It,
          "k-required": e.required,
          "k-disabled": e.disabled,
          "k-focus": u
        },
        e.className
      ),
      onFocus: xe,
      onBlur: ve
    },
    /* @__PURE__ */ n.createElement(
      "div",
      {
        className: "k-signature-canvas",
        ref: i,
        tabIndex: ie(e.tabIndex, e.disabled),
        role: "img",
        id: e.id,
        "aria-label": e.ariaLabel,
        "aria-labelledby": e.ariaLabelledBy,
        "aria-describedby": e.ariaDescribedBy,
        "aria-disabled": e.disabled ? "true" : void 0
      }
    ),
    /* @__PURE__ */ n.createElement("div", { className: "k-signature-actions k-signature-actions-top" }, T && /* @__PURE__ */ n.createElement(
      ge,
      {
        className: "k-signature-action k-signature-maximize",
        ref: f,
        icon: "hyperlink-open",
        svgIcon: Ma,
        fillMode: "flat",
        size: e.size,
        onClick: je,
        "aria-label": q,
        title: q
      }
    ), E && /* @__PURE__ */ n.createElement(
      ge,
      {
        className: "k-signature-action k-signature-minimize k-rotate-180",
        ref: o,
        icon: "hyperlink-open",
        svgIcon: Ma,
        fillMode: "flat",
        size: e.size,
        onClick: De,
        "aria-label": Z,
        title: Z
      }
    )),
    !e.hideLine && /* @__PURE__ */ n.createElement(
      "div",
      {
        className: "k-signature-line",
        style: { zIndex: 2, pointerEvents: "none" }
      }
    ),
    /* @__PURE__ */ n.createElement("div", { className: "k-signature-actions k-signature-actions-bottom" }, H && /* @__PURE__ */ n.createElement(
      ge,
      {
        className: "k-signature-action k-signature-clear",
        icon: "x",
        svgIcon: zt,
        fillMode: "flat",
        size: e.size,
        onClick: wt,
        "aria-label": p,
        title: p
      }
    )),
    _ && /* @__PURE__ */ n.createElement(Hn, { ref: c }, /* @__PURE__ */ n.createElement(
      St,
      {
        ...e,
        ...at(),
        value: L,
        maximized: !0,
        exportScale: 1 / v * g,
        open: !1,
        onChange: C,
        onClose: J
      }
    ))
  );
});
St.propTypes = {
  value: r.string,
  width: r.number,
  height: r.number,
  tabIndex: r.number,
  dir: r.string,
  ariaDescribedBy: r.string,
  ariaLabelledBy: r.string,
  ariaLabel: r.string,
  readOnly: r.bool,
  disabled: r.bool,
  validationMessage: r.string,
  required: r.bool,
  onChange: r.func,
  onFocus: r.func,
  onBlur: r.func,
  onOpen: r.func,
  onClose: r.func,
  size: r.oneOf([null, "small", "medium", "large"]),
  rounded: r.oneOf([null, "small", "medium", "large"]),
  fillMode: r.oneOf([null, "solid", "flat", "outline"])
};
St.displayName = "KendoSignature";
St.defaultProps = {
  strokeWidth: 1,
  smooth: !1,
  popupScale: Ln,
  exportScale: Rn,
  maximizable: !0,
  disabled: !1,
  required: !1,
  validityStyles: !0,
  onChange: (a) => Me,
  onFocus: (a) => Me,
  onBlur: (a) => Me,
  onOpen: (a) => Me,
  onClose: (a) => Me,
  size: "medium",
  rounded: "medium",
  fillMode: "solid"
};
const xa = n.forwardRef((a, t) => {
  pe(me);
  const e = n.useRef(null), s = n.useRef(null), l = n.useRef(), i = n.useCallback(
    () => {
      var H;
      return l.current !== void 0 ? l.current : (H = e.current) == null ? void 0 : H.value;
    },
    []
  );
  n.useImperativeHandle(
    s,
    () => ({
      get element() {
        return e.current;
      },
      get name() {
        return e.current && e.current.name;
      },
      get value() {
        return i();
      }
    })
  ), n.useImperativeHandle(
    t,
    () => s.current
  );
  const {
    size: c,
    fillMode: o,
    rounded: f,
    className: d,
    dir: m,
    style: u,
    prefix: h = ca.prefix,
    suffix: y = ca.suffix,
    valid: M,
    // Destruct to avoid warning when used inside a form field
    modified: D,
    touched: N,
    visited: L,
    ...S
  } = a, [w] = qe(h), [B] = qe(y), [O, I] = n.useState(!1), F = (H) => {
    I(!0);
  }, _ = (H) => {
    I(!1);
  }, T = n.useCallback(
    (H) => {
      l.current = H.target.value, a.onChange && a.onChange.call(void 0, {
        syntheticEvent: H,
        nativeEvent: H.nativeEvent,
        value: H.target.value,
        target: s.current
      }), l.current = void 0;
    },
    [a.onChange]
  ), { onFocus: E, onBlur: V } = Bn({
    onFocus: F,
    onBlur: _,
    onSyncFocus: a.onFocus,
    onSyncBlur: a.onBlur
  });
  return /* @__PURE__ */ n.createElement(
    "span",
    {
      style: u,
      dir: m,
      className: G(
        "k-textbox k-input",
        {
          [`k-input-${ne.sizeMap[c] || c}`]: c,
          [`k-input-${o}`]: o,
          [`k-rounded-${ne.roundedMap[f] || f}`]: f
        },
        {
          "k-focus": O,
          "k-required": a.required,
          "k-disabled": a.disabled,
          "k-invalid": a.valid === !1
        },
        d
      ),
      onFocus: E,
      onBlur: V
    },
    /* @__PURE__ */ n.createElement(w, null),
    /* @__PURE__ */ n.createElement(
      "input",
      {
        ref: e,
        className: "k-input-inner",
        ...S,
        onChange: T
      }
    ),
    /* @__PURE__ */ n.createElement(B, null)
  );
}), ca = {
  prefix: (a) => null,
  suffix: (a) => null,
  size: "medium",
  rounded: "medium",
  fillMode: "solid"
};
xa.propTypes = {
  size: r.oneOf([null, "small", "medium", "large"]),
  rounded: r.oneOf([null, "small", "medium", "large", "full"]),
  fillMode: r.oneOf([null, "solid", "flat", "outline"])
};
xa.displayName = "KendoReactTextBoxComponent";
xa.defaultProps = ca;
const hr = n.forwardRef((a, t) => {
  const e = n.useRef(null), s = n.useRef(null);
  return n.useImperativeHandle(
    e,
    () => ({ element: s.current })
  ), n.useImperativeHandle(
    t,
    () => e.current
  ), /* @__PURE__ */ n.createElement("span", { ...a, className: G("k-clear-value", a.className) });
});
hr.displayName = "KendoReactInputClearValue";
const pr = n.forwardRef((a, t) => {
  const e = n.useRef(null), s = n.useRef(null);
  return n.useImperativeHandle(
    e,
    () => ({ element: s.current })
  ), n.useImperativeHandle(
    t,
    () => e.current
  ), /* @__PURE__ */ n.createElement("span", { ...a, className: G("k-input-prefix", a.className) });
});
pr.displayName = "KendoReactInputPrefix";
const mr = n.forwardRef((a, t) => {
  const e = n.useRef(null), s = n.useRef(null);
  return n.useImperativeHandle(
    e,
    () => ({ element: s.current })
  ), n.useImperativeHandle(
    t,
    () => e.current
  ), /* @__PURE__ */ n.createElement("span", { ...a, className: G("k-input-separator", a.className) });
});
mr.displayName = "KendoReactInputSeparator";
const gr = n.forwardRef((a, t) => {
  const e = n.useRef(null), s = n.useRef(null);
  return n.useImperativeHandle(
    e,
    () => ({ element: s.current })
  ), n.useImperativeHandle(
    t,
    () => e.current
  ), /* @__PURE__ */ n.createElement("span", { ...a, className: G("k-input-suffix", a.className) });
});
gr.displayName = "KendoReactInputSuffix";
const br = n.forwardRef((a, t) => /* @__PURE__ */ n.createElement(fe, { ref: t, ...a, className: G("k-input-validation-icon", a.className) }));
br.displayName = "KendoReactInputValidationIcon";
export {
  va as Checkbox,
  Ws as CheckboxPropsContext,
  pa as ColorGradient,
  ys as ColorGradientPropsContext,
  vt as ColorGradientWithoutContext,
  ha as ColorInput,
  ma as ColorPalette,
  Es as ColorPalettePropsContext,
  kt as ColorPaletteWithoutContext,
  ga as ColorPicker,
  Rs as ColorPickerPropsContext,
  Sn as FlatColorPicker,
  vn as Input,
  hr as InputClearValue,
  pr as InputPrefix,
  rs as InputPropsContext,
  mr as InputSeparator,
  gr as InputSuffix,
  br as InputValidationIcon,
  gt as InputWithoutContext,
  $s as MaskedTextBox,
  yt as MaskedTextBoxWithoutContext,
  ze as NumericTextBox,
  as as NumericTextBoxPropsContext,
  xs as PALETTEPRESETS,
  X as RANGE_ACTION,
  de as RATING_ACTION,
  xt as RadioButton,
  Ys as RadioButtonPropsContext,
  ka as RadioGroup,
  Js as RadioGroupPropsContext,
  ba as RangeSlider,
  Ks as RangeSliderPropsContext,
  Ca as Rating,
  Et as RatingItem,
  rr as RatingPropsContext,
  kn as SLIDER_LABEL_ATTRIBUTE,
  St as Signature,
  fr as SignaturePropsContext,
  ia as Slider,
  Rr as SliderLabel,
  bt as SliderWithoutContext,
  js as Switch,
  Ct as SwitchWithoutContext,
  ya as TextArea,
  Qs as TextAreaPropsContext,
  xa as TextBox,
  $ as inputsMessages,
  Za as isCorrectValue,
  oa as isHalf,
  Ot as isSelected,
  zs as maskingChanged,
  Ye as numericDecreaseValue,
  Xe as numericIncreaseValue,
  Hs as rangeReducer,
  sr as ratingReducer,
  Ta as sanitizeNumber,
  ye as toRound
};
